(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-top-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-top-bar')) {
    customElements.define('campaign-top-bar', class CampaignTopBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', this.handleClick);
        this.initializeExpiry();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        window.clearTimeout(this.resetTimer);
        window.clearTimeout(this.expiryTimer);
        this.initialized = false;
      }

      initializeExpiry() {
        const expiryTimestamp = this.getCopenhagenTimestamp(this.dataset.hideAt);
        if (expiryTimestamp === null) return;

        this.expiryTimestamp = expiryTimestamp;
        this.updateExpiryVisibility();
      }

      updateExpiryVisibility = () => {
        const remainingMilliseconds = this.expiryTimestamp - Date.now();

        if (remainingMilliseconds <= 0) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.expiryTimer = window.setTimeout(
          this.updateExpiryVisibility,
          Math.min(remainingMilliseconds, 2147483647)
        );
      };

      getCopenhagenTimestamp(value) {
        const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
        if (!match) return null;

        const [, yearValue, monthValue, dayValue, hourValue, minuteValue] = match;
        const desired = {
          year: Number(yearValue),
          month: Number(monthValue),
          day: Number(dayValue),
          hour: Number(hourValue),
          minute: Number(minuteValue)
        };

        if (
          desired.year < 2000 ||
          desired.month < 1 || desired.month > 12 ||
          desired.day < 1 || desired.day > 31 ||
          desired.hour > 23 ||
          desired.minute > 59
        ) return null;

        const desiredAsUtc = Date.UTC(
          desired.year,
          desired.month - 1,
          desired.day,
          desired.hour,
          desired.minute
        );
        const normalizedDate = new Date(desiredAsUtc);

        if (
          normalizedDate.getUTCFullYear() !== desired.year ||
          normalizedDate.getUTCMonth() + 1 !== desired.month ||
          normalizedDate.getUTCDate() !== desired.day
        ) return null;

        try {
          const formatter = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Europe/Copenhagen',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hourCycle: 'h23'
          });
          let timestamp = desiredAsUtc;

          for (let attempt = 0; attempt < 4; attempt += 1) {
            const copenhagen = this.getDateParts(formatter, timestamp);
            const copenhagenAsUtc = Date.UTC(
              copenhagen.year,
              copenhagen.month - 1,
              copenhagen.day,
              copenhagen.hour,
              copenhagen.minute
            );
            const correction = desiredAsUtc - copenhagenAsUtc;
            timestamp += correction;
            if (correction === 0) break;
          }

          const result = this.getDateParts(formatter, timestamp);
          const isExactMatch = Object.keys(desired).every((key) => result[key] === desired[key]);
          return isExactMatch ? timestamp : null;
        } catch (error) {
          return null;
        }
      }

      getDateParts(formatter, timestamp) {
        return formatter.formatToParts(new Date(timestamp)).reduce((parts, part) => {
          if (part.type !== 'literal') parts[part.type] = Number(part.value);
          return parts;
        }, {});
      }

      handleClick = async (event) => {
        const button = event.target.closest('[data-copy-code]');
        if (!button || !this.contains(button)) return;

        const code = button.dataset.copyCode;
        const codeText = button.querySelector('[data-code-text]');
        const status = this.querySelector('[data-copy-status]');
        if (!code || !codeText) return;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            const textArea = document.createElement('textarea');
            textArea.value = code;
            textArea.setAttribute('readonly', '');
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          const copiedText = this.dataset.copiedText || 'Copied';
          window.clearTimeout(this.resetTimer);
          codeText.textContent = copiedText;
          button.classList.add('is-copied');
          if (status) status.textContent = `${copiedText}: ${code}`;

          this.resetTimer = window.setTimeout(() => {
            codeText.textContent = code;
            button.classList.remove('is-copied');
            if (status) status.textContent = '';
          }, 1800);
        } catch (error) {
          if (status) status.textContent = this.dataset.copyError || `Could not copy. The code is ${code}.`;
        }
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-utility-bar"] && !Shopify.designMode) return;
  try {
    
  class HeaderUtilityBar {
    constructor(section) {
      this.section = section;
      this.shell = section.querySelector('[data-bar-shell]');
      this.carousel = section.querySelector('[data-bar-carousel]');
      this.track = section.querySelector('[data-bar-track]');
      this.viewport = section.querySelector('.header-utility-bar__viewport');
      this.controls = section.querySelector('[data-bar-controls]');
      this.desktopContacts = section.querySelector('[data-desktop-contacts]');
      this.panelArea = section.querySelector('[data-panel-area]');
      this.backdrop = section.querySelector('[data-panel-backdrop]');
      this.placeholder = section.parentElement ? section.parentElement.querySelector('[data-bar-placeholder]') : null;
      this.hoverRegion = this.shell || this.carousel || section;
      this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
      this.interactionMode = section.dataset.interactionMode;
      this.rotationInterval = Number(section.dataset.rotationInterval || 5000);
      this.resumeDelay = Number(section.dataset.resumeDelay || 3000);
      this.positionMode = section.dataset.positionMode;
      this.setupSliderTrack();
      this.items = this.collectItems();
      this.panels = Array.from(section.querySelectorAll('[data-panel]'));
      this.copyButtons = Array.from(section.querySelectorAll('[data-copy-discount]'));
      this.prevButton = section.querySelector('[data-utility-bar-prev]');
      this.nextButton = section.querySelector('[data-utility-bar-next]');
      this.status = section.querySelector('[data-rotation-status]');
      this.statusCounter = section.querySelector('[data-status-counter]');
      this.progressRing = section.querySelector('[data-progress-ring]');
      this.activeIndex = Math.max(
        this.items.findIndex((item) => item.classList.contains('is-active')),
        0
      );
      this.rotationTimer = null;
      this.resumeTimer = null;
      this.progressFrame = null;
      this.progressStart = null;
      this.progressEnd = null;
      this.progressDuration = 0;
      this.sliderFrame = null;
      this.sliderResumeTimer = null;
      this.sliderLastTimestamp = null;
      this.sliderOffset = 0;
      this.sliderLoopWidth = 0;
      this.sliderOriginalWidth = 0;
      this.sliderFitsDesktop = false;
      this.sliderSpeed = 28;
      this.sliderPaused = false;
      this.sliderHovering = false;
      this.sliderPressing = false;
      this.sliderDragging = false;
      this.sliderDragged = false;
      this.sliderPointerId = null;
      this.sliderDragStartX = 0;
      this.sliderDragStartOffset = 0;
      this.countdownLabels = this.getCountdownLabels();
      this.panelTransitionDuration = 280;
      this.scrollHandler = null;
      this.resizeHandler = this.syncOffset.bind(this);
      this.mediaQueryHandler = this.handleViewportModeChange.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);
      this.keydownHandler = this.handleKeydown.bind(this);
      this.countdownTimer = null;
      this.lastScrollY = window.scrollY || window.pageYOffset || 0;
      this.progressCircumference = this.progressRing ? 2 * Math.PI * Number(this.progressRing.getAttribute('r') || 0) : 0;
      this.bind();
      this.activate(this.activeIndex);
      this.startRotation();
      this.setupCountDowns();
      this.syncOffset();
      window.addEventListener('resize', this.resizeHandler);
      if (this.desktopMediaQuery.addEventListener) {
        this.desktopMediaQuery.addEventListener('change', this.mediaQueryHandler);
      } else {
        this.desktopMediaQuery.addListener(this.mediaQueryHandler);
      }
      document.addEventListener('click', this.documentClickHandler);
      document.addEventListener('keydown', this.keydownHandler);
    }

    collectItems() {
      return Array.from(this.section.querySelectorAll('[data-bar-item]')).filter((item) => {
        if (item.hasAttribute('data-slider-clone')) {
          return false;
        }

        return !(this.desktopMediaQuery.matches && item.hasAttribute('data-desktop-static-contact'));
      });
    }

    collectSliderOriginalItems() {
      if (!this.track) {
        return [];
      }

      return Array.from(this.track.querySelectorAll('[data-bar-item]')).filter((item) => !item.hasAttribute('data-slider-clone'));
    }

    setupSliderTrack() {
      if (this.interactionMode !== 'slider' || !this.track || this.track.hasAttribute('data-slider-ready')) {
        return;
      }

      const originals = Array.from(this.track.querySelectorAll('[data-bar-item]')).filter((item) => !item.hasAttribute('data-slider-clone'));
      if (originals.length < 2) {
        return;
      }

      const fragment = document.createDocumentFragment();
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.classList.remove('is-active');
        clone.setAttribute('data-slider-clone', '');
        clone.setAttribute('aria-hidden', 'false');
        clone.inert = false;
        fragment.appendChild(clone);
      });

      this.track.appendChild(fragment);
      this.track.setAttribute('data-slider-ready', 'true');
    }

    bind() {
      if (this.prevButton) {
        this.prevClickHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.step(-1, true);
        };
        this.prevButton.addEventListener('click', this.prevClickHandler);
      }

      if (this.nextButton) {
        this.nextClickHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.step(1, true);
        };
        this.nextButton.addEventListener('click', this.nextClickHandler);
      }

      this.section.querySelectorAll('[data-panel-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const target = trigger.dataset.panelTarget;
          this.togglePanel(target, trigger);
          this.handleInteraction();
        });
      });

      this.section.querySelectorAll('[data-panel-close]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closePanels();
          this.handleInteraction();
        });
      });

      this.copyButtons.forEach((button) => {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();
          const code = button.dataset.discountCode;
          if (!code) {
            return;
          }

          try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(code);
            }
            const label = button.querySelector('.header-utility-bar__discount-button-label');
            if (label) {
              label.textContent = button.dataset.copiedLabel || label.textContent;
            }
            button.classList.add('is-copied');
            window.clearTimeout(button.copyResetTimer);
            button.copyResetTimer = window.setTimeout(() => {
              button.classList.remove('is-copied');
              if (label) {
                label.textContent = button.dataset.defaultLabel || label.textContent;
              }
            }, 2000);
          } catch (error) {
          }
        });
      });

      if (this.backdrop) {
        this.backdropClickHandler = () => {
          this.closePanels();
          this.handleInteraction();
        };
        this.backdrop.addEventListener('click', this.backdropClickHandler);
      }

      if (this.interactionMode === 'slider' && this.hoverRegion) {
        this.sliderEnterHandler = () => {
          if (this.sliderDragging) {
            return;
          }
          this.sliderHovering = true;
          window.clearTimeout(this.sliderResumeTimer);
          this.pauseSliderMotion();
        };
        this.sliderLeaveHandler = () => {
          if (this.sliderDragging) {
            return;
          }
          this.sliderHovering = false;
          this.scheduleSliderResume();
        };

        this.hoverRegion.addEventListener('pointerenter', this.sliderEnterHandler);
        this.hoverRegion.addEventListener('pointerleave', this.sliderLeaveHandler);
      }

      if (this.interactionMode === 'slider' && this.carousel) {
        this.sliderPointerDownHandler = (event) => {
          if (this.sliderFitsDesktop) {
            return;
          }

          if (event.pointerType === 'mouse' && event.button !== 0) {
            return;
          }

          this.refreshSliderMetrics();
          this.sliderPressing = true;
          this.sliderDragging = false;
          this.sliderDragged = false;
          this.sliderPointerId = event.pointerId;
          this.sliderDragStartX = event.clientX;
          this.sliderDragStartOffset = this.sliderOffset;
          this.sliderHovering = true;
          window.clearTimeout(this.sliderResumeTimer);
          this.pauseSliderMotion();
        };

        this.sliderPointerMoveHandler = (event) => {
          if ((!this.sliderPressing && !this.sliderDragging) || event.pointerId !== this.sliderPointerId) {
            return;
          }

          const deltaX = event.clientX - this.sliderDragStartX;
          if (!this.sliderDragging && Math.abs(deltaX) > 8) {
            this.sliderDragging = true;
            if (this.carousel.setPointerCapture) {
              this.carousel.setPointerCapture(event.pointerId);
            }
          }

          if (!this.sliderDragging) {
            return;
          }

          if (!this.sliderDragged) {
            this.sliderDragged = true;
          }

          this.sliderOffset = this.normalizeSliderOffset(this.sliderDragStartOffset - deltaX);
          if (this.track) {
            this.track.style.transform = `translate3d(-${this.sliderOffset}px, 0, 0)`;
          }
        };

        this.sliderPointerUpHandler = (event) => {
          if (event.pointerId !== this.sliderPointerId) {
            return;
          }

          this.finishSliderDrag();
        };

        this.sliderClickCaptureHandler = (event) => {
          if (!this.sliderDragged) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          this.sliderDragged = false;
        };

        this.carousel.addEventListener('pointerdown', this.sliderPointerDownHandler);
        this.carousel.addEventListener('pointermove', this.sliderPointerMoveHandler);
        this.carousel.addEventListener('pointerup', this.sliderPointerUpHandler);
        this.carousel.addEventListener('pointercancel', this.sliderPointerUpHandler);
        this.carousel.addEventListener('click', this.sliderClickCaptureHandler, true);
      }

      if (this.interactionMode !== 'slider' && this.carousel) {
        this.touchStartHandler = (event) => {
          const touch = event.touches ? event.touches[0] : null;
          if (!touch) {
            return;
          }

          this.touchStartX = touch.clientX;
          this.touchStartY = touch.clientY;
          this.touchDeltaX = 0;
          this.touchDeltaY = 0;
        };

        this.touchMoveHandler = (event) => {
          const touch = event.touches ? event.touches[0] : null;
          if (!touch || this.touchStartX == null || this.touchStartY == null) {
            return;
          }

          this.touchDeltaX = touch.clientX - this.touchStartX;
          this.touchDeltaY = touch.clientY - this.touchStartY;
        };

        this.touchEndHandler = () => {
          if (this.touchStartX == null) {
            return;
          }

          const threshold = 34;
          if (Math.abs(this.touchDeltaX) > threshold && Math.abs(this.touchDeltaX) > Math.abs(this.touchDeltaY)) {
            this.step(this.touchDeltaX < 0 ? 1 : -1, true);
          }

          this.touchStartX = null;
          this.touchStartY = null;
          this.touchDeltaX = 0;
          this.touchDeltaY = 0;
        };

        this.carousel.addEventListener('touchstart', this.touchStartHandler, { passive: true });
        this.carousel.addEventListener('touchmove', this.touchMoveHandler, { passive: true });
        this.carousel.addEventListener('touchend', this.touchEndHandler);
      }

      if (this.positionMode === 'reveal_on_scroll_up') {
        this.scrollHandler = this.handleScroll.bind(this);

        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        this.handleScroll();
      }
    }

    handleViewportModeChange() {
      if (window.initializeHeaderUtilityBars) {
        window.initializeHeaderUtilityBars();
      }
    }

    getCountdownLabels() {
      const locale = (document.documentElement.lang || '').toLowerCase();
      const prefix = locale.split('-')[0];
      const localeLabels = {
        ar: { day: 'ي', hour: 'س', minute: 'د', second: 'ث' },
        bg: { day: 'Д', hour: 'Ч', minute: 'М', second: 'С' },
        cs: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        da: { day: 'D', hour: 'T', minute: 'M', second: 'S' },
        de: { day: 'T', hour: 'Std', minute: 'Min', second: 'Sek' },
        el: { day: 'Η', hour: 'Ω', minute: 'Λ', second: 'Δ' },
        en: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        es: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        et: { day: 'P', hour: 'T', minute: 'M', second: 'S' },
        fi: { day: 'P', hour: 'T', minute: 'M', second: 'S' },
        fr: { day: 'J', hour: 'H', minute: 'M', second: 'S' },
        he: { day: 'י', hour: 'ש', minute: 'ד', second: 'שנ' },
        hr: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        hu: { day: 'N', hour: 'Ó', minute: 'P', second: 'M' },
        it: { day: 'G', hour: 'H', minute: 'M', second: 'S' },
        ja: { day: '日', hour: '時間', minute: '分', second: '秒' },
        ko: { day: '일', hour: '시간', minute: '분', second: '초' },
        lt: { day: 'D', hour: 'V', minute: 'M', second: 'S' },
        lv: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        nb: { day: 'D', hour: 'T', minute: 'M', second: 'S' },
        nl: { day: 'D', hour: 'U', minute: 'M', second: 'S' },
        no: { day: 'D', hour: 'T', minute: 'M', second: 'S' },
        pl: { day: 'D', hour: 'G', minute: 'M', second: 'S' },
        pt: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        ro: { day: 'Z', hour: 'O', minute: 'M', second: 'S' },
        ru: { day: 'Д', hour: 'Ч', minute: 'М', second: 'С' },
        sk: { day: 'D', hour: 'H', minute: 'M', second: 'S' },
        sl: { day: 'D', hour: 'U', minute: 'M', second: 'S' },
        sv: { day: 'D', hour: 'T', minute: 'M', second: 'S' },
        tr: { day: 'G', hour: 'S', minute: 'Dk', second: 'Sn' },
        uk: { day: 'Д', hour: 'Г', minute: 'Х', second: 'С' },
        zh: { day: '天', hour: '时', minute: '分', second: '秒' }
      };

      if (localeLabels[prefix]) {
        return localeLabels[prefix];
      }

      return { day: 'D', hour: 'H', minute: 'M', second: 'S' };
    }

    activate(index) {
      if (!this.items.length) {
        this.section.hidden = true;
        this.updateOffset(0);
        this.updateNavigationVisibility();
        this.updateStatus();
        return;
      }

      if (this.interactionMode === 'slider') {
        this.activeIndex = 0;
        this.items.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-hidden', 'false');
          item.inert = false;
          item.querySelectorAll('a, button').forEach((control) => {
            control.tabIndex = 0;
          });
        });
        if (this.track) {
          this.track.style.transform = this.interactionMode === 'slider'
            ? `translate3d(-${this.sliderOffset}px, 0, 0)`
            : 'translate3d(0, 0, 0)';
        }
        this.updateNavigationVisibility();
        this.updateStatus();
        this.syncOffset();
        return;
      }

      this.activeIndex = (index + this.items.length) % this.items.length;
      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === this.activeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        item.inert = !isActive;
        item.querySelectorAll('a, button').forEach((control) => {
          control.tabIndex = isActive ? 0 : -1;
        });
      });
      if (this.track) {
        this.track.style.transform = `translate3d(-${this.activeIndex * 100}%, 0, 0)`;
      }
      this.updateNavigationVisibility();
      this.updateStatus();
      this.syncOffset();
    }

    step(direction, userInitiated = false) {
      const openPanelId = this.getOpenPanelId();
      this.activate(this.activeIndex + direction);
      if (openPanelId) {
        this.openPanelForActiveItem();
      } else {
        this.closePanels();
      }
      if (userInitiated) {
        this.handleInteraction();
      }
    }

    startRotation() {
      if (this.interactionMode === 'slider') {
        this.startSliderMotion();
        this.clearProgressClock();
        return;
      }

      if (this.items.length <= 1 || this.section.classList.contains('has-open-panel')) {
        this.clearProgressClock();
        return;
      }

      window.clearTimeout(this.rotationTimer);
      this.setProgressWindow(this.rotationInterval);
      this.rotationTimer = window.setTimeout(() => {
        this.step(1);
        this.startRotation();
      }, this.rotationInterval);
    }

    handleInteraction() {
      if (this.interactionMode === 'slider') {
        this.pauseSliderMotion();
        this.scheduleSliderResume();
        return;
      }

      window.clearTimeout(this.rotationTimer);
      window.clearTimeout(this.resumeTimer);
      if (this.interactionMode !== 'slider' && this.items.length > 1) {
        this.setProgressWindow(this.resumeDelay);
      }
      this.resumeTimer = window.setTimeout(() => {
        this.startRotation();
      }, this.resumeDelay);
    }

    handleDocumentClick(event) {
      if (!this.section.contains(event.target)) {
        this.closePanels();
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closePanels();
      }
    }

    handleScroll() {
      const currentY = window.scrollY || window.pageYOffset || 0;
      const shellHeight = this.shell ? this.shell.offsetHeight : this.section.offsetHeight;
      const delta = currentY - this.lastScrollY;
      const threshold = 10;

      if (currentY <= shellHeight) {
        this.section.classList.remove('is-hidden');
      } else if (!this.section.classList.contains('has-open-panel')) {
        if (delta > threshold) {
          this.section.classList.add('is-hidden');
        } else if (delta < -threshold) {
          this.section.classList.remove('is-hidden');
        }
      }

      this.lastScrollY = currentY;
      this.syncOffset();
    }

    getOpenPanelId() {
      const openPanel = this.panels.find((panel) => !panel.hidden);
      return openPanel ? openPanel.id : null;
    }

    openPanelForActiveItem() {
      const activeItem = this.items[this.activeIndex];
      if (!activeItem) {
        return;
      }

      const trigger = activeItem.querySelector('[data-panel-trigger]');
      if (!trigger) {
        this.closePanels();
        return;
      }

      this.togglePanel(trigger.dataset.panelTarget, trigger);
    }

    togglePanel(targetId, trigger) {
      const panel = this.section.querySelector(`#${targetId}`);
      const isOpen = panel && panel.classList.contains('is-open');
      this.closePanels();

      if (!panel || isOpen) {
        return;
      }

      window.clearTimeout(panel.closeTimer);
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.remove('is-closing');
      trigger.setAttribute('aria-expanded', 'true');
      if (this.backdrop) {
        window.clearTimeout(this.backdrop.hideTimer);
        this.backdrop.hidden = false;
        window.requestAnimationFrame(() => {
          this.backdrop.classList.add('is-visible');
        });
      }
      if (this.interactionMode === 'slider') {
        window.clearTimeout(this.sliderResumeTimer);
        this.pauseSliderMotion();
      }
      this.section.classList.add('has-open-panel');
      this.section.classList.remove('is-hidden');
      window.requestAnimationFrame(() => {
        panel.classList.add('is-open');
      });
      this.syncOffset();
    }

    closePanels() {
      let hadOpenPanel = false;
      this.panels.forEach((panel) => {
        if (!panel.hidden || panel.classList.contains('is-open')) {
          hadOpenPanel = true;
        }
        window.clearTimeout(panel.closeTimer);
        panel.classList.remove('is-open');
        if (!panel.hidden) {
          panel.classList.add('is-closing');
          panel.setAttribute('aria-hidden', 'true');
          panel.closeTimer = window.setTimeout(() => {
            panel.hidden = true;
            panel.classList.remove('is-closing');
            this.syncOffset();
          }, this.panelTransitionDuration);
        } else {
          panel.hidden = true;
          panel.classList.remove('is-closing');
          panel.setAttribute('aria-hidden', 'true');
        }
      });

      this.section.querySelectorAll('[data-panel-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      if (this.backdrop) {
        this.backdrop.classList.remove('is-visible');
        window.clearTimeout(this.backdrop.hideTimer);
        this.backdrop.hideTimer = window.setTimeout(() => {
          this.backdrop.hidden = true;
        }, this.panelTransitionDuration);
      }

      this.section.classList.remove('has-open-panel');
      if (hadOpenPanel) {
        this.syncOffset();
        if (this.interactionMode === 'slider') {
          if (!this.isHoveringSliderRegion()) {
            this.scheduleSliderResume();
          }
        } else {
          this.startRotation();
        }
      }
    }

    setupCountDowns() {
      const countdownItems = this.items.filter((item) => item.dataset.countdownEnd);
      if (!countdownItems.length) {
        return;
      }

      const update = () => {
        const now = Math.floor(Date.now() / 1000);

        countdownItems.forEach((item) => {
          if (item.dataset.countdownComplete === 'true') {
            return;
          }

          const end = Number(item.dataset.countdownEnd);
          const targets = this.section.querySelectorAll(`[data-panel-block-id="${item.dataset.blockId}"] [data-countdown-target], [data-block-id="${item.dataset.blockId}"] [data-countdown-target]`);
          if (!targets.length) {
            return;
          }

          if (!end || end <= now) {
            if (item.dataset.blockType === 'promotions_auto') {
              const refreshKey = `header-utility-bar-auto-refresh-${item.dataset.blockId}-${end}`;

              if (window.sessionStorage.getItem(refreshKey)) {
                window.sessionStorage.removeItem(refreshKey);
                this.expireItem(item);
                return;
              }

              window.sessionStorage.setItem(refreshKey, 'true');
              window.location.reload();
              return;
            }

            this.expireItem(item);
            return;
          }

          const remaining = end - now;
          const days = Math.floor(remaining / 86400);
          const hours = Math.floor((remaining % 86400) / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;
          const labels = this.countdownLabels || this.getCountdownLabels();
          const countdownText = days > 0
            ? `${days}${labels.day} : ${String(hours).padStart(2, '0')}${labels.hour} : ${String(minutes).padStart(2, '0')}${labels.minute} : ${String(seconds).padStart(2, '0')}${labels.second}`
            : `${String(hours).padStart(2, '0')}${labels.hour} : ${String(minutes).padStart(2, '0')}${labels.minute} : ${String(seconds).padStart(2, '0')}${labels.second}`;
          targets.forEach((target) => {
            target.textContent = countdownText;
          });
        });
      };

      update();
      this.countdownTimer = window.setInterval(update, 1000);
    }

    expireItem(item) {
      const blockId = item.dataset.blockId;
      const panel = blockId ? this.section.querySelector(`#HeaderUtilityBarPanel-${blockId}`) : null;
      const itemIndex = this.items.indexOf(item);

      if (panel) {
        panel.remove();
      }

      item.remove();
      this.items = this.items.filter((entry) => entry !== item);
      this.panels = Array.from(this.section.querySelectorAll('[data-panel]'));

      if (!this.items.length) {
        this.closePanels();
        this.section.hidden = true;
        this.updateOffset(0);
        if (this.countdownTimer) {
          window.clearInterval(this.countdownTimer);
        }
        return;
      }

      this.activate(Math.min(itemIndex, this.items.length - 1));
      this.syncOffset();
    }

    syncOffset() {
      const isFloating = this.positionMode === 'fixed' || this.positionMode === 'reveal_on_scroll_up';
      this.items = this.collectItems();
      this.updateStatus();
      this.syncResponsiveMetrics();
      this.syncPanelBounds();
      this.refreshSliderMetrics();
      if (this.interactionMode === 'slider' && !this.sliderFrame && !this.sliderPaused && !this.section.classList.contains('has-open-panel')) {
        this.startSliderMotion();
      }
      const shellHeight = this.shell ? Math.ceil(this.shell.getBoundingClientRect().height) : Math.ceil(this.section.getBoundingClientRect().height);
      if (this.backdrop) {
        const shellRect = this.shell ? this.shell.getBoundingClientRect() : null;
        const shellBottom = shellRect ? Math.max(0, Math.round(shellRect.bottom)) : shellHeight;
        this.backdrop.style.top = `${shellBottom}px`;
      }
      const reservedHeight = isFloating ? shellHeight : 0;
      const visibleHeight = this.positionMode === 'reveal_on_scroll_up' && this.section.classList.contains('is-hidden')
        ? 0
        : reservedHeight;

      if (this.placeholder) {
        if (visibleHeight === 0) {
          this.placeholder.hidden = true;
          this.placeholder.style.height = '0px';
        } else {
          this.placeholder.hidden = false;
          this.placeholder.style.height = `${visibleHeight}px`;
        }
      }

      this.updateOffset(visibleHeight);
    }

    syncPanelBounds() {
      if (!this.panelArea || !this.shell) {
        return;
      }

      const viewportRect = this.viewport ? this.viewport.getBoundingClientRect() : null;
      const shellRect = this.shell.getBoundingClientRect();
      const shellStyles = window.getComputedStyle(this.shell);
      const shellBottomPadding = Number.parseFloat(shellStyles.paddingBottom || '0') || 0;
      const panelTop = viewportRect
        ? Math.max(0, Math.round(shellRect.bottom - viewportRect.top - shellBottomPadding))
        : Math.max(0, Math.ceil(shellRect.height - shellBottomPadding));
      this.panelArea.style.top = `${panelTop}px`;

      if (viewportRect && window.innerWidth < 750) {
        this.section.style.setProperty('--header-utility-bar-panel-mobile-left', `${Math.round(viewportRect.left)}px`);
      } else {
        this.section.style.removeProperty('--header-utility-bar-panel-mobile-left');
      }
    }

    refreshSliderMetrics() {
      if (this.interactionMode !== 'slider' || !this.track || !this.carousel) {
        return;
      }

      const originalItems = this.collectSliderOriginalItems();
      this.sliderOriginalWidth = originalItems.reduce((total, item) => total + Math.ceil(item.getBoundingClientRect().width), 0);
      this.sliderFitsDesktop = Boolean(
        this.desktopMediaQuery.matches
        && this.sliderOriginalWidth > 0
        && this.sliderOriginalWidth <= Math.floor(this.carousel.getBoundingClientRect().width)
      );
      this.section.classList.toggle('header-utility-bar--slider-desktop-fit', this.sliderFitsDesktop);

      if (this.sliderFitsDesktop) {
        window.clearTimeout(this.sliderResumeTimer);
        if (this.sliderFrame) {
          window.cancelAnimationFrame(this.sliderFrame);
          this.sliderFrame = null;
        }
        this.sliderLastTimestamp = null;
        this.sliderOffset = 0;
        this.sliderLoopWidth = 0;
        this.track.style.transform = 'translate3d(0, 0, 0)';
        return;
      }

      this.sliderLoopWidth = this.track.scrollWidth / 2;
      if (this.sliderLoopWidth > 0) {
        this.sliderOffset = this.normalizeSliderOffset(this.sliderOffset);
        this.track.style.transform = `translate3d(-${this.sliderOffset}px, 0, 0)`;
      }
    }

    normalizeSliderOffset(value) {
      if (!this.sliderLoopWidth) {
        return Math.max(0, value || 0);
      }

      let nextValue = value;
      if (nextValue >= this.sliderLoopWidth) {
        nextValue = nextValue % this.sliderLoopWidth;
      }
      if (nextValue < 0) {
        nextValue = ((nextValue % this.sliderLoopWidth) + this.sliderLoopWidth) % this.sliderLoopWidth;
      }

      return nextValue;
    }

    startSliderMotion(force = false) {
      if (this.interactionMode !== 'slider' || !this.carousel || !this.track || this.section.classList.contains('has-open-panel')) {
        return;
      }

      if (this.sliderFitsDesktop) {
        return;
      }

      if (!force && this.isHoveringSliderRegion()) {
        return;
      }

      this.refreshSliderMetrics();
      if (!this.sliderLoopWidth) {
        window.requestAnimationFrame(() => this.startSliderMotion(force));
        return;
      }

      this.sliderPaused = false;
      if (this.sliderFrame) {
        return;
      }

      this.sliderLastTimestamp = null;
      this.sliderFrame = window.requestAnimationFrame(this.stepSliderMotion.bind(this));
    }

    stepSliderMotion(timestamp) {
      if (this.sliderPaused || this.sliderDragging || !this.carousel || !this.sliderLoopWidth) {
        this.sliderFrame = null;
        return;
      }

      if (this.sliderLastTimestamp == null) {
        this.sliderLastTimestamp = timestamp;
      }

      const delta = timestamp - this.sliderLastTimestamp;
      this.sliderLastTimestamp = timestamp;
      this.sliderOffset = this.normalizeSliderOffset(this.sliderOffset + (this.sliderSpeed * delta) / 1000);

      this.track.style.transform = `translate3d(-${this.sliderOffset}px, 0, 0)`;

      this.sliderFrame = window.requestAnimationFrame(this.stepSliderMotion.bind(this));
    }

    pauseSliderMotion() {
      if (this.interactionMode !== 'slider') {
        return;
      }

      this.sliderPaused = true;
      window.clearTimeout(this.sliderResumeTimer);
      if (this.sliderFrame) {
        window.cancelAnimationFrame(this.sliderFrame);
        this.sliderFrame = null;
      }
      this.sliderLastTimestamp = null;
    }

    scheduleSliderResume() {
      if (this.interactionMode !== 'slider') {
        return;
      }

      window.clearTimeout(this.sliderResumeTimer);
      this.sliderResumeTimer = window.setTimeout(() => {
        if (this.section.classList.contains('has-open-panel') || this.sliderDragging) {
          return;
        }

        if (this.isHoveringSliderRegion()) {
          this.scheduleSliderResume();
          return;
        }

        this.sliderHovering = false;
        this.startSliderMotion(true);
      }, this.resumeDelay);
    }

    finishSliderDrag() {
      if (!this.sliderPressing && !this.sliderDragging) {
        return;
      }

      if (this.carousel && this.carousel.releasePointerCapture && this.sliderPointerId != null) {
        try {
          this.carousel.releasePointerCapture(this.sliderPointerId);
        } catch (error) {
        }
      }

      this.sliderPressing = false;
      this.sliderDragging = false;
      this.sliderPointerId = null;
      this.sliderHovering = false;
      this.sliderOffset = this.normalizeSliderOffset(this.sliderOffset);
      if (this.track) {
        this.track.style.transform = `translate3d(-${this.sliderOffset}px, 0, 0)`;
      }

      if (!this.section.classList.contains('has-open-panel')) {
        this.scheduleSliderResume();
      }
    }

    isHoveringSliderRegion() {
      return Boolean(this.hoverRegion && this.hoverRegion.matches && this.hoverRegion.matches(':hover'));
    }

    updateOffset(value) {
      document.documentElement.style.setProperty('--header-utility-bar-offset', `${value}px`);
      document.documentElement.style.setProperty('--header-utility-bar-sticky-offset', `${value}px`);
    }

    syncResponsiveMetrics() {
      const controlsWidth = this.measureElementWidth(this.controls);
      const contactWidth = this.measureElementWidth(this.desktopContacts);
      const desktopReserve = Math.max(controlsWidth, contactWidth);
      this.section.style.setProperty('--header-utility-bar-controls-space', `${controlsWidth}px`);
      this.section.style.setProperty('--header-utility-bar-contact-space', `${contactWidth}px`);
      this.section.style.setProperty('--header-utility-bar-desktop-reserve', `${desktopReserve}px`);
    }

    measureElementWidth(element) {
      if (!element || element.hidden) {
        return 0;
      }

      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return 0;
      }

      return Math.ceil(element.getBoundingClientRect().width);
    }

    updateNavigationVisibility() {
      const shouldShow = this.interactionMode !== 'slider' && this.items.length > 1;
      if (this.prevButton) {
        this.prevButton.hidden = !shouldShow;
      }
      if (this.nextButton) {
        this.nextButton.hidden = !shouldShow;
      }
      if (this.status) {
        this.status.hidden = !shouldShow;
      }
    }

    updateStatus() {
      if (!this.statusCounter) {
        return;
      }

      const total = this.items.length;
      const current = total ? Math.min(this.activeIndex + 1, total) : 0;
      this.statusCounter.textContent = `${current}/${total}`;
    }

    setProgressWindow(duration) {
      if (!this.progressRing || duration <= 0) {
        return;
      }

      this.clearProgressClock();
      this.progressStart = performance.now();
      this.progressDuration = duration;
      this.progressEnd = this.progressStart + duration;
      this.renderProgress(this.progressStart);
    }

    renderProgress(now) {
      if (!this.progressRing || !this.progressCircumference || !this.progressEnd || !this.progressDuration) {
        return;
      }

      const clampedNow = Math.min(now, this.progressEnd);
      const elapsed = clampedNow - this.progressStart;
      const progress = Math.max(0, Math.min(1, elapsed / this.progressDuration));
      const arcLength = this.progressCircumference * 0.32;
      this.progressRing.style.strokeDasharray = `${arcLength} ${this.progressCircumference}`;
      this.progressRing.style.strokeDashoffset = `${-progress * this.progressCircumference}`;
      this.progressRing.style.transform = 'rotate(-90deg)';

      if (clampedNow < this.progressEnd) {
        this.progressFrame = window.requestAnimationFrame(this.renderProgress.bind(this));
      } else {
        this.progressFrame = null;
      }
    }

    clearProgressClock() {
      if (this.progressFrame) {
        window.cancelAnimationFrame(this.progressFrame);
        this.progressFrame = null;
      }

      this.progressStart = null;
      this.progressEnd = null;
      this.progressDuration = 0;

      if (this.progressRing) {
        const arcLength = this.progressCircumference * 0.32;
        this.progressRing.style.strokeDasharray = `${arcLength} ${this.progressCircumference}`;
        this.progressRing.style.strokeDashoffset = '0';
        this.progressRing.style.transform = 'rotate(-90deg)';
      }
    }

    destroy() {
      window.clearTimeout(this.rotationTimer);
      window.clearTimeout(this.resumeTimer);
      window.clearTimeout(this.sliderResumeTimer);
      this.clearProgressClock();
      this.pauseSliderMotion();
      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
      }
      window.removeEventListener('resize', this.resizeHandler);
      if (this.desktopMediaQuery.removeEventListener) {
        this.desktopMediaQuery.removeEventListener('change', this.mediaQueryHandler);
      } else {
        this.desktopMediaQuery.removeListener(this.mediaQueryHandler);
      }
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler);
      }
      if (this.hoverRegion && this.sliderEnterHandler) {
        this.hoverRegion.removeEventListener('pointerenter', this.sliderEnterHandler);
        this.hoverRegion.removeEventListener('pointerleave', this.sliderLeaveHandler);
      }
      if (this.carousel && this.sliderPointerDownHandler) {
        this.carousel.removeEventListener('pointerdown', this.sliderPointerDownHandler);
        this.carousel.removeEventListener('pointermove', this.sliderPointerMoveHandler);
        this.carousel.removeEventListener('pointerup', this.sliderPointerUpHandler);
        this.carousel.removeEventListener('pointercancel', this.sliderPointerUpHandler);
        this.carousel.removeEventListener('click', this.sliderClickCaptureHandler, true);
      }
      if (this.carousel && this.touchStartHandler) {
        this.carousel.removeEventListener('touchstart', this.touchStartHandler);
        this.carousel.removeEventListener('touchmove', this.touchMoveHandler);
        this.carousel.removeEventListener('touchend', this.touchEndHandler);
      }
      if (this.backdrop && this.backdropClickHandler) {
        this.backdrop.removeEventListener('click', this.backdropClickHandler);
      }
      document.removeEventListener('click', this.documentClickHandler);
      document.removeEventListener('keydown', this.keydownHandler);
      this.updateOffset(0);
      if (this.placeholder) {
        this.placeholder.hidden = true;
        this.placeholder.style.height = '0px';
      }
    }
  }

  if (!window.themeHeaderUtilityBars) {
    window.themeHeaderUtilityBars = {};
  }

  window.initializeHeaderUtilityBars = (root = document) => {
    const sections = [];

    if (root.matches && root.matches('[data-header-utility-bar]')) {
      sections.push(root);
    }

    root.querySelectorAll('[data-header-utility-bar]').forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      const key = section.dataset.sectionId;
      if (window.themeHeaderUtilityBars[key]) {
        window.themeHeaderUtilityBars[key].destroy();
      }
      window.themeHeaderUtilityBars[key] = new HeaderUtilityBar(section);
    });
  };

  window.initializeHeaderUtilityBars();

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      window.initializeHeaderUtilityBars(event.target);
    }
  });

  document.addEventListener('shopify:section:reorder', () => {
    window.initializeHeaderUtilityBars();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-performance-dashboard"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-promotion-analytics-dashboard]');
    const source = root?.querySelector('[data-source]');
    if (!source) return;
    const parse = (value) => { try { return typeof value === 'string' ? JSON.parse(value) : value; } catch { return null; } };
    const normaliseMetrics = (source) => ({ eligible_units:Number(source?.eligible_units ?? source?.promotion_units_sum ?? 0), net_units:Number(source?.net_units ?? source?.promotion_units_sum ?? 0), units_with_promotion_code:Number(source?.units_with_promotion_code ?? 0), net_revenue_dkk:Number(source?.net_revenue_dkk ?? source?.net_revenue_dkk_sum ?? 0), gross_profit_dkk:Number(source?.gross_profit_dkk ?? source?.gross_profit_dkk_sum ?? 0) });
    const normaliseAnalytics = (value) => { const analytics=parse(value); if (!analytics) return null; return { ...analytics, stores:(analytics.stores || []).map((store) => ({ ...store, metrics:normaliseMetrics(store.metrics || store), daily:(store.daily || []).map((day) => { const metrics=day.metrics || day; return { ...day, ...normaliseMetrics(metrics), has_gross_profit_dkk:metrics.gross_profit_dkk != null || metrics.gross_profit_dkk_sum != null }; }) })) }; };
    const escape = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#039;', '"':'&quot;' })[character]);
    const dkk = new Intl.NumberFormat('da-DK', { style:'currency', currency:'DKK', maximumFractionDigits:0 });
    const number = new Intl.NumberFormat('da-DK', { maximumFractionDigits:0 });
    const percent = (value) => `${new Intl.NumberFormat('da-DK', { maximumFractionDigits:1 }).format(value || 0)}%`;
    const labels = { allPromotions:root.dataset.allPromotions, allGroups:root.dataset.allGroups, allStores:root.dataset.allStores, noData:root.dataset.noData, day:root.dataset.day, week:root.dataset.week, month:root.dataset.month, grossUnits:root.dataset.grossUnits, netRevenue:root.dataset.netRevenue, netUnits:root.dataset.netUnits, codeUseRate:root.dataset.codeUseRate, storeRecords:root.dataset.storeRecords, promotionPerformance:root.dataset.promotionPerformance, discountCode:root.dataset.discountCode, codeUnits:root.dataset.codeUnits, unitsWithoutCode:root.dataset.unitsWithoutCode, contribution:root.dataset.contribution, weekday:root.dataset.weekday, revenueShare:root.dataset.revenueShare, revenueShareNote:root.dataset.revenueShareNote, chartMetric:root.dataset.chartMetric, promotionId:root.dataset.promotionId, comparison:root.dataset.comparison, noComparison:root.dataset.noComparison, previousWeek:root.dataset.previousWeek, sameWeekdaysLastWeek:root.dataset.sameWeekdaysLastWeek, customBaseline:root.dataset.customBaseline, baseline:root.dataset.baseline, promotionShareStore:root.dataset.promotionShareStore, revenueReconciliation:root.dataset.revenueReconciliation, promotionAttributedRevenue:root.dataset.promotionAttributedRevenue, revenueOutsidePromotions:root.dataset.revenueOutsidePromotions, totalStoreMerchandiseRevenue:root.dataset.totalStoreMerchandiseRevenue, storeRevenueBasis:root.dataset.storeRevenueBasis, chartStoreRevenue:root.dataset.chartStoreRevenue, awaitingStoreTurnover:root.dataset.awaitingStoreTurnover, revenueUplift:root.dataset.revenueUplift, unitUplift:root.dataset.unitUplift, marginUplift:root.dataset.marginUplift, unavailableCogs:root.dataset.unavailableCogs, topInsights:root.dataset.topInsights, bestPromotion:root.dataset.bestPromotion, lowestPromotion:root.dataset.lowestPromotion, highestCodeUse:root.dataset.highestCodeUse, largestAdoptionGap:root.dataset.largestAdoptionGap, dataFreshness:root.dataset.dataFreshness, lastRefreshed:root.dataset.lastRefreshed, periodCoverage:root.dataset.periodCoverage, notAvailable:root.dataset.notAvailable };
    let raw; try { raw = JSON.parse(source.textContent); } catch { return; }
    const groups = (raw.groups || []).map((group) => ({ ...group, analytics:normaliseAnalytics(group.analytics), promotions:(group.promotions || []).map((promotion) => ({ ...promotion, analytics:normaliseAnalytics(promotion.analytics) })) })).filter((group) => group.analytics || group.promotions.some((promotion) => promotion.analytics));
    const groupInput = root.querySelector('[data-group]'); const promotionInput = root.querySelector('[data-promotion]'); const storeInput = root.querySelector('[data-store]'); const fromInput = root.querySelector('[data-date-from]'); const toInput = root.querySelector('[data-date-to]'); const intervalInput = root.querySelector('[data-interval]'); const chartMetricInput = root.querySelector('[data-chart-metric]'); const hiddenSeriesKeys = new Set(); let storeRevenueVisible=true; let promotionSort={ key:'net_revenue_dkk', direction:'descending' };
    const status = root.querySelector('[data-status]'); const kpis = root.querySelector('[data-kpis]'); const chart = root.querySelector('[data-chart]'); const chartTooltip = root.querySelector('[data-chart-tooltip]'); const chartHeading = root.querySelector('[data-chart-heading]'); const chartLegend = root.querySelector('[data-chart-legend]'); const periodsBody = root.querySelector('[data-periods]'); const storesBody = root.querySelector('[data-stores]'); const groupsBody = root.querySelector('[data-groups-performance]'); const promotionsBody = root.querySelector('[data-promotions-performance]'); const promotionsTable = promotionsBody.closest('table'); const periodHeading = root.querySelector('[data-period-heading]'); const weekdayHeading = root.querySelector('[data-weekday-heading]'); const benchmarkPanel = root.querySelector('[data-benchmark]'); const freshnessPanel = root.querySelector('[data-freshness]');
    const empty = () => ({ eligible_units:0, net_units:0, units_with_promotion_code:0, net_revenue_dkk:0, gross_profit_dkk:0 });
    const add = (target, sourceMetrics) => { Object.keys(target).forEach((key) => { target[key] += Number(sourceMetrics?.[key] || 0); }); return target; };
    const weekStart = (date) => { const value = new Date(`${date}T00:00:00Z`); value.setUTCDate(value.getUTCDate() - ((value.getUTCDay() + 6) % 7)); return value.toISOString().slice(0,10); };
    const monthStart = (date) => date.slice(0,7);
    const selectedGroups = () => groupInput.value === 'all' ? groups : groups.filter((entry) => entry.handle === groupInput.value);
    const group = () => selectedGroups()[0] || groups[0];
    const promotionCandidates = () => selectedGroups().flatMap((entry) => entry.promotions.map((promotion) => ({ ...promotion, group_handle:entry.handle, group_label:entry.label, key:`${entry.handle}:${promotion.handle}` }))).filter((entry) => entry.analytics);
    const promotions = () => (promotionInput.value === 'all' ? promotionCandidates() : promotionCandidates().filter((entry) => entry.key === promotionInput.value));
    const recordsFor = (analytics, promotion = null) => (analytics?.stores || []).filter((store) => storeInput.value === 'all' || store.store === storeInput.value).map((store) => ({ ...store, promotion }));
    const promotionRecords = () => promotions().flatMap((promotion) => recordsFor(promotion.analytics,promotion));
    const records = () => {
      if (promotionInput.value !== 'all') return promotionRecords();
      return selectedGroups().flatMap((entry) => {
        const entryPromotions=entry.promotions.filter((promotion) => promotion.analytics).map((promotion) => ({ ...promotion, group_handle:entry.handle, group_label:entry.label, key:`${entry.handle}:${promotion.handle}` }));
        const detailed=entryPromotions.flatMap((promotion) => recordsFor(promotion.analytics,promotion));
        return detailed.length ? detailed : recordsFor(entry.analytics);
      });
    };
    const dateInRange = (date) => (!fromInput.value || date >= fromInput.value) && (!toInput.value || date <= toInput.value);
    const analysisRecords = () => records().map((store) => { if (!(store.daily || []).length) return (fromInput.value || toInput.value) ? null : store; const daily=store.daily.filter((day) => dateInRange(day.date)); return daily.length ? { ...store, daily, metrics:daily.reduce((total,day) => add(total,day),empty()) } : null; }).filter(Boolean);
    const promotionPerformance = () => { const values = new Map(); analysisRecords().forEach((store) => { const promotion=store.promotion; if (!promotion) return; const row=values.get(promotion.key) || { promotion, metrics:empty() }; add(row.metrics,store.metrics); values.set(promotion.key,row); }); const rows=[...values.values()]; return sortedPromotions(rows,rows.reduce((total,row) => total+row.metrics.net_revenue_dkk,0)); };
    const promotionSortValue = (row, key, totalRevenue) => ({ promotion:promotionItemName(row.promotion), promotion_id:promotionId(row.promotion), discount_code:row.promotion.discount_code || '', eligible_units:row.metrics.eligible_units, code_units:row.metrics.units_with_promotion_code, code_use_rate:row.metrics.eligible_units ? row.metrics.units_with_promotion_code / row.metrics.eligible_units * 100 : 0, net_revenue_dkk:row.metrics.net_revenue_dkk, revenue_share:totalRevenue ? row.metrics.net_revenue_dkk / totalRevenue * 100 : 0 })[key];
    const sortedPromotions = (rows, totalRevenue) => [...rows].sort((left,right) => { const leftValue=promotionSortValue(left,promotionSort.key,totalRevenue); const rightValue=promotionSortValue(right,promotionSort.key,totalRevenue); const comparison=typeof leftValue === 'string' ? leftValue.localeCompare(rightValue,undefined,{ sensitivity:'base' }) : leftValue-rightValue; return promotionSort.direction === 'ascending' ? comparison : -comparison; });
    const updatePromotionSortHeaders = () => root.querySelectorAll('[data-promotion-sort]').forEach((button) => { const direction=button.dataset.promotionSort === promotionSort.key ? promotionSort.direction : 'none'; button.dataset.sortDirection=direction; button.closest('th').setAttribute('aria-sort',direction); });
    const sortCellValue = (value) => { const text=String(value || '').trim().replace(/\u00a0/g,' '); if (/^\d{4}-\d{2}-\d{2}/.test(text)) return { type:'number',value:Date.parse(text.slice(0,10)) }; if (/^[\d.,\s]+(?:%|kr\.)?$/.test(text)) return { type:'number',value:Number(text.replace(/kr\.|%|\s/g,'').replace(/\./g,'').replace(',','.')) || 0 }; return { type:'text',value:text.toLocaleLowerCase() }; };
    const setupTableSorting = () => root.querySelectorAll('table').forEach((table) => { const body=table.tBodies[0]; if (!body) return; [...table.tHead.rows[0].cells].forEach((header) => { if (header.querySelector('button')) return; const button=document.createElement('button'); button.type='button'; button.textContent=header.textContent.trim(); button.dataset.sortDirection='none'; header.textContent=''; header.append(button); button.addEventListener('click',() => { const direction=button.dataset.sortDirection === 'ascending' ? 'descending' : 'ascending'; const headers=[...table.tHead.rows[0].cells].filter((cell) => !cell.hidden); const index=headers.indexOf(header); if (index < 0) return; [...table.tHead.rows[0].cells].forEach((cell) => { cell.setAttribute('aria-sort','none'); const control=cell.querySelector('button'); if (control) control.dataset.sortDirection='none'; }); button.dataset.sortDirection=direction; header.setAttribute('aria-sort',direction); [...body.rows].sort((left,right) => { const a=sortCellValue(left.cells[index]?.textContent); const b=sortCellValue(right.cells[index]?.textContent); const comparison=a.type === 'number' && b.type === 'number' ? a.value-b.value : String(a.value).localeCompare(String(b.value)); return direction === 'ascending' ? comparison : -comparison; }).forEach((row) => body.append(row)); }); }); });
    setupTableSorting();
    const groupSchedule = (handle) => { const schedule=groups.find((entry) => entry.handle === handle)?.analytics?.group || {}; return { starts_at:schedule.starts_at, ends_at:schedule.ends_at }; };
    const groupPerformance = () => { const values = new Map(); analysisRecords().forEach((store) => { const promotion=store.promotion; const key=promotion?.group_handle || group().handle; const row=values.get(key) || { key, label:promotion?.group_label || group().label, schedule:groupSchedule(key), metrics:empty() }; add(row.metrics,store.metrics); values.set(key,row); }); return [...values.values()].sort((a,b) => b.metrics.net_revenue_dkk - a.metrics.net_revenue_dkk); };
    const stores = () => { const values = new Map(); analysisRecords().forEach((store) => { const row = values.get(store.store) || { store:store.store_name || store.store, metrics:empty() }; add(row.metrics, store.metrics); values.set(store.store,row); }); return [...values.values()].sort((a,b) => b.metrics.net_revenue_dkk - a.metrics.net_revenue_dkk); };
    const coolColours = ['#173f73','#1f5fa8','#147f9a','#3e77c9','#266a5a','#4569a8','#1880c0','#5b5ea6'];
    const warmColours = ['#b51632','#d8442f','#df6a17','#a82d49','#cc5d0f','#c23558','#e48c16','#8d3146'];
    if (!groups.length) { status.textContent = labels.noData; return; }
    const copenhagenTimeZone = 'Europe/Copenhagen';
    const weekday = (date) => new Intl.DateTimeFormat('en-GB',{ weekday:'short', timeZone:copenhagenTimeZone }).format(new Date(`${date}T12:00:00Z`));
    const promotionId = (promotion) => { const id=String(promotion?.id || promotion?.handle || '').trim().toUpperCase(); return id.replace(/^(\d{2}W\d{2})(P\d+(?:-[A-Z0-9]+)*)$/,'$1-$2'); };
    const promotionDiscountType = (promotion) => String(promotion?.discount_type || promotion?.analytics?.promotion?.discount_application_type || promotion?.analytics?.stores?.find((store) => store?.promotion_item?.discount_application_type)?.promotion_item?.discount_application_type || '').replace(/\s*\([^)]*\)/g,'').trim();
    const promotionInternalName = (promotion) => { const rawId=String(promotion?.id || promotion?.handle || '').trim().toUpperCase(); const id=promotionId(promotion); const label=String(promotion?.label || '').trim(); return label && label !== id && label.toUpperCase() !== rawId ? label : ''; };
    const promotionName = (promotion) => { const parts=[promotionId(promotion),promotionDiscountType(promotion),promotionInternalName(promotion)].filter(Boolean); return parts.length ? parts.join(' · ') : (promotion?.label || labels.allPromotions); };
    const promotionItemName = promotionName;
    const scheduleLabel = (schedule) => { const format=(value) => { const date=new Date(value); if (Number.isNaN(date.getTime())) return ''; const parts=Object.fromEntries(new Intl.DateTimeFormat('en-GB',{ timeZone:copenhagenTimeZone, year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', hourCycle:'h23', timeZoneName:'short' }).formatToParts(date).filter((part) => part.type !== 'literal').map((part) => [part.type,part.value])); return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute} ${parts.timeZoneName}`; }; const startsAt=format(schedule?.starts_at); const endsAt=format(schedule?.ends_at); return startsAt && endsAt ? `${startsAt} – ${endsAt}` : startsAt || endsAt || '—'; };
    const promotionColour = (promotion) => { const orderedGroups=[...groups].sort((left,right) => left.handle.localeCompare(right.handle)); const groupIndex=Math.max(0,orderedGroups.findIndex((entry) => entry.handle === promotion?.group_handle)); const palette=groupIndex % 2 ? warmColours : coolColours; const owningGroup=orderedGroups[groupIndex]; const promotionIndex=Math.max(0,(owningGroup?.promotions || []).findIndex((entry) => entry.handle === promotion?.handle)); return palette[promotionIndex % palette.length]; };
    const chartMetric = () => { const key=chartMetricInput.value; const label=chartMetricInput.options[chartMetricInput.selectedIndex]?.textContent || labels.netRevenue; const value=(metrics) => key === 'code_use_rate' ? (metrics.eligible_units ? metrics.units_with_promotion_code / metrics.eligible_units * 100 : 0) : Number(metrics?.[key] || 0); const format=(value) => key === 'net_revenue_dkk' ? dkk.format(value) : key === 'code_use_rate' ? percent(value) : number.format(value); return { key, label, value, format }; };
    const monthLabel = (key) => new Intl.DateTimeFormat('en-GB',{ month:'short', year:'numeric', timeZone:'UTC' }).format(new Date(`${key}-01T00:00:00Z`));
    const periodLabel = (key) => intervalInput.value === 'day' ? `${key} · ${weekday(key)}` : intervalInput.value === 'month' ? monthLabel(key) : `${labels.week} ${key}`;
    const interactivePeriods = () => { const values=new Map(); analysisRecords().forEach((store) => (store.daily || []).forEach((day) => { const key=intervalInput.value === 'month' ? monthStart(day.date) : intervalInput.value === 'week' ? weekStart(day.date) : day.date; const row=values.get(key) || { key, metrics:empty(), series:new Map() }; add(row.metrics,day); const promotion=store.promotion || { key:'group-total', label:labels.allPromotions }; const seriesKey=promotion.key || promotion.handle; const series=row.series.get(seriesKey) || { promotion, metrics:empty() }; add(series.metrics,day); row.series.set(seriesKey,series); values.set(key,row); })); if (intervalInput.value === 'day') { const keys=[...values.keys()].sort(); const start=fromInput.value || keys[0]; const end=toInput.value || keys[keys.length-1]; if (start && end && start <= end) { const cursor=new Date(`${start}T00:00:00Z`); const last=new Date(`${end}T00:00:00Z`); while (cursor <= last) { const key=cursor.toISOString().slice(0,10); if (!values.has(key)) values.set(key,{ key, metrics:empty(), series:new Map() }); cursor.setUTCDate(cursor.getUTCDate()+1); } } } return [...values.values()].sort((a,b) => a.key.localeCompare(b.key)).map((row) => ({ ...row, series:[...row.series.values()] })); };
    const rangeDays = (start,end) => start && end && start <= end ? Math.floor((new Date(`${end}T00:00:00Z`) - new Date(`${start}T00:00:00Z`)) / 86400000) + 1 : 0;
    const shiftDate = (date,days) => { const value=new Date(`${date}T00:00:00Z`); value.setUTCDate(value.getUTCDate()+days); return value.toISOString().slice(0,10); };
    const activeRange = () => { const dates=analysisRecords().flatMap((store) => (store.daily || []).map((day) => day.date)).sort(); return { start:fromInput.value || dates[0] || '', end:toInput.value || dates[dates.length-1] || '' }; };
    const metricsForRange = (start,end) => records().reduce((total,store) => { const daily=store.daily || []; if (daily.length) daily.filter((day) => day.date >= start && day.date <= end).forEach((day) => add(total,day)); else if (!start && !end) add(total,store.metrics); return total; },empty());
    const hasDataForRange = (start,end) => records().some((store) => (store.daily || []).some((day) => day.date >= start && day.date <= end));
    const totalStoreBenchmark = (start,end) => { const expected=new Set(); const totals=new Map(); const selectedStoreIds=[...new Set(records().map((store) => store.store).filter(Boolean))]; const save=(store,date,value) => { const revenue=Number(value); if (!store || !date || !Number.isFinite(revenue)) return; const key=`${store}|${date}`; if (!totals.has(key)) totals.set(key,revenue); }; if (rangeDays(start,end)) { const cursor=new Date(`${start}T00:00:00Z`); const last=new Date(`${end}T00:00:00Z`); while (cursor <= last) { const date=cursor.toISOString().slice(0,10); selectedStoreIds.forEach((store) => expected.add(`${store}|${date}`)); cursor.setUTCDate(cursor.getUTCDate()+1); } } selectedGroups().forEach((entry) => [entry.analytics,...entry.promotions.map((promotion) => promotion.analytics)].filter(Boolean).forEach((analytics) => (analytics.total_store_daily || analytics.store_daily_totals || analytics.daily_store_totals || []).forEach((day) => { if (day.date >= start && day.date <= end) save(day.store || day.store_code,day.date,day.net_revenue_dkk ?? day.total_store_net_revenue_dkk ?? day.total_store_revenue_dkk); }))); const complete=expected.size > 0 && [...expected].every((key) => totals.has(key)); const daily=new Map(); [...expected].forEach((key) => { const date=key.split('|')[1]; daily.set(date,(daily.get(date) || 0) + Number(totals.get(key) || 0)); }); return { available:complete, net_revenue_dkk:[...expected].reduce((sum,key) => sum + Number(totals.get(key) || 0),0), daily }; };
    const analyticsSources = () => selectedGroups().flatMap((entry) => [entry.analytics,...entry.promotions.map((promotion) => promotion.analytics)]).filter(Boolean);
    const freshness = () => analyticsSources().flatMap((analytics) => [analytics.generated_at,analytics.refreshed_at,analytics.updated_at,analytics.computed_at]).filter(Boolean).map((value) => new Date(value)).filter((value) => !Number.isNaN(value.valueOf())).sort((left,right) => right-left)[0];
    const analysisRow = (label,value,className='') => `<div><dt>${escape(label)}</dt><dd${className ? ` class="${className}"` : ''}>${escape(value)}</dd></div>`;
    const signed = (value,format) => `${value > 0 ? '+' : ''}${format(value)}`;
    const renderAnalysis = () => { const current=activeRange(); const currentDays=rangeDays(current.start,current.end); const benchmark=totalStoreBenchmark(current.start,current.end); const promotionMetrics=metricsForRange(current.start,current.end); const share=benchmark.available && benchmark.net_revenue_dkk ? promotionMetrics.net_revenue_dkk / benchmark.net_revenue_dkk * 100 : null; const refreshed=freshness(); const coverage=currentDays ? `${current.start} – ${current.end} · ${number.format(currentDays)} ${labels.day.toLocaleLowerCase()}` : labels.notAvailable; freshnessPanel.innerHTML=`<div class="promotion-performance-dashboard__panel-heading"><p>${escape(labels.contribution)}</p><h2 class="h3">${escape(labels.dataFreshness)}</h2></div><dl class="promotion-performance-dashboard__analysis-list">${analysisRow(labels.lastRefreshed,refreshed ? new Intl.DateTimeFormat('en-GB',{ dateStyle:'medium', timeStyle:'short' }).format(refreshed) : labels.notAvailable)}${analysisRow(labels.periodCoverage,coverage)}${analysisRow(labels.revenueShare,share === null ? labels.notAvailable : percent(share))}</dl>`; };
    const renderRevenueReconciliation = () => {
      const current=activeRange(); const promotionMetrics=metricsForRange(current.start,current.end); const benchmark=totalStoreBenchmark(current.start,current.end); const outsideRevenue=benchmark.available ? benchmark.net_revenue_dkk-promotionMetrics.net_revenue_dkk : null; const share=benchmark.available && benchmark.net_revenue_dkk ? promotionMetrics.net_revenue_dkk/benchmark.net_revenue_dkk*100 : null;
      benchmarkPanel.innerHTML=`<div class="promotion-performance-dashboard__panel-heading" data-store-revenue-reconciliation><p>${escape(labels.contribution)}</p><h2 class="h3">${escape(labels.revenueReconciliation)}</h2></div><dl class="promotion-performance-dashboard__analysis-list">${analysisRow(labels.promotionAttributedRevenue,dkk.format(promotionMetrics.net_revenue_dkk))}${analysisRow(labels.revenueOutsidePromotions,outsideRevenue === null ? labels.notAvailable : dkk.format(outsideRevenue))}${analysisRow(labels.totalStoreMerchandiseRevenue,benchmark.available ? dkk.format(benchmark.net_revenue_dkk) : labels.notAvailable)}${analysisRow(labels.promotionShareStore,share === null ? labels.notAvailable : percent(share))}</dl><p class="promotion-performance-dashboard__analysis-note">${escape(benchmark.available ? labels.storeRevenueBasis : labels.awaitingStoreTurnover)}</p>`;
    };
    const scheduleRevenueReconciliation = () => window.requestAnimationFrame(renderRevenueReconciliation);
    root.addEventListener('change',scheduleRevenueReconciliation);
    const storeRevenueForPeriod = (daily,key) => [...daily.entries()].filter(([date]) => intervalInput.value === 'day' ? date === key : intervalInput.value === 'week' ? weekStart(date) === key : monthStart(date) === key).reduce((sum,[,value]) => sum + value,0);
    const renderChartBenchmark = () => {
      const metric=chartMetric(); const current=activeRange(); const benchmark=totalStoreBenchmark(current.start,current.end); const periodRows=interactivePeriods(); const displayTotal=metric.key === 'net_revenue_dkk' && benchmark.available;
      const visibleMetrics=(row) => row.series.filter((series) => !hiddenSeriesKeys.has(series.promotion.key || series.promotion.handle)).reduce((total,series) => add(total,series.metrics),empty());
      const totals=periodRows.map((row) => displayTotal ? storeRevenueForPeriod(benchmark.daily,row.key) : 0); const promotionValues=periodRows.map((row) => metric.value(visibleMetrics(row))); const fullPromotionValues=periodRows.map((row) => metric.value(row.metrics));
      const maximum=Math.max(1,...promotionValues.map((value,index) => displayTotal && storeRevenueVisible ? totals[index] : value));
      [...chart.querySelectorAll('.promotion-performance-dashboard__bar')].forEach((bar,index) => {
        const row=periodRows[index]; if (!row) return; const promotionValue=promotionValues[index]; const promotionShare=totals[index] ? promotionValue / totals[index] * 100 : 0; const value=bar.firstElementChild; const period=bar.lastElementChild;
        if (value) { value.className='promotion-performance-dashboard__bar-value'; value.innerHTML=displayTotal ? `<span>All: ${escape(dkk.format(totals[index]))}</span><small>Promo: ${escape(metric.format(promotionValue))} (${escape(percent(promotionShare))})</small>` : `<span>${escape(metric.format(promotionValue))}</span>`; }
        if (period) { period.className='promotion-performance-dashboard__bar-period'; period.innerHTML=intervalInput.value === 'day' ? `<span>${escape(row.key)}</span><small>${escape(weekday(row.key))}</small>` : `<span>${escape(periodLabel(row.key))}</span>`; }
        const stack=bar.querySelector('.promotion-performance-dashboard__bar-stack'); if (!stack) return;
        stack.querySelectorAll('[data-chart-segment]').forEach((segment) => { const series=row.series.find((candidate) => (candidate.promotion.key || candidate.promotion.handle) === segment.dataset.seriesKey); const segmentValue=series ? metric.value(series.metrics) : 0; segment.style.height=`${Math.max(3,segmentValue / maximum * 100)}%`; });
        const existing=stack.querySelector('.promotion-performance-dashboard__bar-total'); const outsideRevenue=Math.max(0,totals[index] - fullPromotionValues[index]);
        if (!displayTotal || !storeRevenueVisible || outsideRevenue <= 0) { if (existing) existing.remove(); return; }
        const totalBar=existing || document.createElement('span'); totalBar.className='promotion-performance-dashboard__bar-total'; totalBar.setAttribute('aria-hidden','true'); totalBar.style.height=`${Math.max(3,outsideRevenue / maximum * 100)}%`; if (!existing) stack.append(totalBar);
      });
      const existingLegend=chartLegend.querySelector('[data-store-revenue-toggle]'); if (!displayTotal) { if (existingLegend) existingLegend.remove(); return; }
      if (existingLegend) { existingLegend.setAttribute('aria-pressed',String(storeRevenueVisible)); return; }
      const toggle=document.createElement('button'); toggle.type='button'; toggle.className='promotion-performance-dashboard__chart-total-legend'; toggle.dataset.storeRevenueToggle='true'; toggle.setAttribute('aria-pressed',String(storeRevenueVisible)); toggle.innerHTML=`<i aria-hidden="true"></i><span>${escape(labels.chartStoreRevenue)}</span>`; chartLegend.prepend(toggle);
    };
    const scheduleChartBenchmark = () => window.requestAnimationFrame(renderChartBenchmark);
    root.addEventListener('change',scheduleChartBenchmark);
    const highlightSeries = (seriesKey) => { if (!seriesKey) return; const segments=[...chart.querySelectorAll('[data-chart-segment]')]; const hasVisibleSeries=segments.some((segment) => segment.dataset.seriesKey === seriesKey); chart.classList.toggle('has-highlight',hasVisibleSeries); segments.forEach((segment) => segment.classList.toggle('is-highlighted',segment.dataset.seriesKey === seriesKey)); chartLegend.querySelectorAll('[data-chart-legend-item]').forEach((item) => item.classList.toggle('is-highlighted',item.dataset.seriesKey === seriesKey)); };
    const clearChartHighlight = () => { chart.classList.remove('has-highlight'); chart.querySelectorAll('[data-chart-segment]').forEach((segment) => segment.classList.remove('is-highlighted')); chartLegend.querySelectorAll('[data-chart-legend-item]').forEach((item) => item.classList.remove('is-highlighted')); chartTooltip.hidden=true; };
    const showChartHighlight = (segment, x, y) => { if (!segment) return; highlightSeries(segment.dataset.seriesKey); const metric=chartMetric(); const units=Number(String(segment.dataset.units || 0).replace(/\D/g,'')) || 0; const codeUnits=Number(String(segment.dataset.codeUnits || 0).replace(/\D/g,'')) || 0; const metricLine=['net_revenue_dkk','eligible_units','units_with_promotion_code'].includes(metric.key) ? '' : `<span>${escape(metric.label)}: ${escape(segment.dataset.value)}</span>`; chartTooltip.innerHTML=`<strong>${escape(segment.dataset.promotion)}</strong><span>${escape(segment.dataset.period)}</span>${metricLine}<span>${escape(labels.netRevenue)}: ${escape(segment.dataset.revenue)}</span><span>${escape(labels.grossUnits)}: ${escape(segment.dataset.units)}</span><span>${escape(labels.codeUnits)}: ${escape(segment.dataset.codeUnits)}</span><span>${escape(labels.unitsWithoutCode)}: ${escape(number.format(Math.max(0,units-codeUnits)))}</span><span>${escape(labels.codeUseRate)}: ${escape(segment.dataset.rate)}</span>`; chartTooltip.hidden=false; chartTooltip.style.left=`${Math.min(window.innerWidth - 220,Math.max(8,x + 14))}px`; chartTooltip.style.top=`${Math.min(window.innerHeight - 150,Math.max(8,y + 14))}px`; };
    chart.addEventListener('pointerover',(event) => showChartHighlight(event.target.closest('[data-chart-segment]'),event.clientX,event.clientY));
    chart.addEventListener('pointermove',(event) => { const segment=event.target.closest('[data-chart-segment]'); if (segment) showChartHighlight(segment,event.clientX,event.clientY); });
    chart.addEventListener('pointerout',(event) => { if (!chart.contains(event.relatedTarget)) clearChartHighlight(); });
    chart.addEventListener('focusin',(event) => showChartHighlight(event.target.closest('[data-chart-segment]'),window.innerWidth / 2,window.innerHeight / 2));
    chart.addEventListener('focusout',(event) => { if (!chart.contains(event.relatedTarget)) clearChartHighlight(); });
    chartLegend.addEventListener('pointerover',(event) => highlightSeries(event.target.closest('[data-chart-legend-item]')?.dataset.seriesKey));
    chartLegend.addEventListener('pointerout',(event) => { if (!chartLegend.contains(event.relatedTarget)) clearChartHighlight(); });
    chartLegend.addEventListener('focusin',(event) => highlightSeries(event.target.closest('[data-chart-legend-item]')?.dataset.seriesKey));
    chartLegend.addEventListener('focusout',(event) => { if (!chartLegend.contains(event.relatedTarget)) clearChartHighlight(); });
    chartLegend.addEventListener('click',(event) => { const item=event.target.closest('[data-chart-legend-item]'); if (!item) return; const seriesKey=item.dataset.seriesKey; if (hiddenSeriesKeys.has(seriesKey)) hiddenSeriesKeys.delete(seriesKey); else hiddenSeriesKeys.add(seriesKey); renderInteractive(); });
    chartLegend.addEventListener('click',(event) => { const toggle=event.target.closest('[data-store-revenue-toggle]'); if (!toggle) return; storeRevenueVisible=!storeRevenueVisible; renderInteractive(); scheduleChartBenchmark(); });
    chartLegend.addEventListener('click',scheduleChartBenchmark);
    const populateInteractive = () => { const available=promotionCandidates(); const currentPromotion=promotionInput.value; const currentStore=storeInput.value; const availableStores=['EU','DK','SE','NO','UK','PL','CH','INT']; promotionInput.innerHTML=`<option value="all">${escape(labels.allPromotions)}</option>${available.map((entry) => `<option value="${escape(entry.key)}">${escape(promotionName(entry,groupInput.value === 'all'))}</option>`).join('')}`; promotionInput.value=available.some((entry) => entry.key === currentPromotion) ? currentPromotion : 'all'; storeInput.innerHTML=`<option value="all">${escape(labels.allStores)}</option>${availableStores.map((store) => `<option value="${store}">${store}</option>`).join('')}`; storeInput.value=availableStores.includes(currentStore) ? currentStore : 'all'; };
    const averageRevenue = (metrics) => metrics.net_units ? metrics.net_revenue_dkk / metrics.net_units : null;
    const ensureAverageKeys = (body,rows) => [...body.querySelectorAll('tr')].forEach((element,index) => { if (element.dataset.analyticsKey) return; const row=rows[index]; if (row) element.dataset.analyticsKey=row.promotion ? promotionId(row.promotion) : row.label; });
    const addAverageCells = (body,rows) => { const metricsByKey=new Map(rows.map((row) => [row.promotion ? promotionId(row.promotion) : row.label,row.metrics])); [...body.querySelectorAll('tr')].forEach((element) => { const metrics=metricsByKey.get(element.dataset.analyticsKey); if (!metrics) return; element.querySelectorAll('[data-average-cell]').forEach((cell) => cell.remove()); const revenue=averageRevenue(metrics); element.insertAdjacentHTML('beforeend',`<td data-average-cell>${revenue === null ? '—' : escape(dkk.format(revenue))}</td><td data-average-cell>—</td>`); }); };
    const ensureRevenueShareKeys = (body,rows) => [...body.querySelectorAll('tr')].forEach((element,index) => { if (element.dataset.analyticsKey) return; const row=rows[index]; if (row) element.dataset.analyticsKey=row.key || row.store; });
    const addRevenueShareCells = (body,rows,totalRevenue) => { const metricsByKey=new Map(rows.map((row) => [row.key || row.store,row.metrics])); [...body.querySelectorAll('tr')].forEach((element) => { const metrics=metricsByKey.get(element.dataset.analyticsKey); if (!metrics) return; element.querySelectorAll('[data-revenue-share-cell]').forEach((cell) => cell.remove()); element.insertAdjacentHTML('beforeend',`<td data-revenue-share-cell>${percent(totalRevenue ? metrics.net_revenue_dkk / totalRevenue * 100 : 0)}</td>`); }); };
    const syncAverageColumns = () => { const totalRevenue=analysisRecords().reduce((sum,store) => sum + store.metrics.net_revenue_dkk,0); const periodRows=interactivePeriods(); const storeRows=stores(); ensureRevenueShareKeys(periodsBody,periodRows); ensureRevenueShareKeys(storesBody,storeRows); addRevenueShareCells(periodsBody,periodRows,totalRevenue); addRevenueShareCells(storesBody,storeRows,totalRevenue); const groupRows=groupPerformance(); const promotionRows=promotionPerformance(); ensureAverageKeys(groupsBody,groupRows); ensureAverageKeys(promotionsBody,promotionRows); addAverageCells(groupsBody,groupRows); addAverageCells(promotionsBody,promotionRows); renderAnalysis(); };
    chartLegend.addEventListener('click',() => requestAnimationFrame(syncAverageColumns));
    promotionsTable.addEventListener('click',(event) => { const button=event.target.closest('[data-promotion-sort]'); if (!button) return; const key=button.dataset.promotionSort; promotionSort=promotionSort.key === key ? { key, direction:promotionSort.direction === 'ascending' ? 'descending' : 'ascending' } : { key, direction:['promotion','promotion_id','discount_code'].includes(key) ? 'ascending' : 'descending' }; updatePromotionSortHeaders(); renderInteractive(); });
    promotionsTable.addEventListener('click',() => requestAnimationFrame(syncAverageColumns));
    [groupInput,promotionInput,storeInput,fromInput,toInput,intervalInput,chartMetricInput].forEach((input) => input.addEventListener('change',() => requestAnimationFrame(syncAverageColumns)));
    requestAnimationFrame(syncAverageColumns);
    updatePromotionSortHeaders();
    scheduleRevenueReconciliation();
    scheduleChartBenchmark();
    const renderInteractive = () => { clearChartHighlight(); const activeRecords=analysisRecords(); const total=activeRecords.reduce((sum,store) => add(sum,store.metrics),empty()); const rate=total.eligible_units ? total.units_with_promotion_code / total.eligible_units * 100 : 0; const metric=chartMetric(); const periodRows=interactivePeriods(); const visibleMetrics=(row) => row.series.filter((series) => !hiddenSeriesKeys.has(series.promotion.key || series.promotion.handle)).reduce((total,series) => add(total,series.metrics),empty()); const storeRows=stores(); const groupRows=groupPerformance(); const promotionRows=promotionPerformance(); const colourByPromotion=new Map(promotionRows.map((row) => [row.promotion.key,promotionColour(row.promotion)])); const storeCount=new Set(activeRecords.map((store) => store.store)).size; const selectedGroupLabel=groupInput.value === 'all' ? labels.allGroups : group().label; chartHeading.textContent=metric.label; periodHeading.textContent=intervalInput.value === 'month' ? labels.month : intervalInput.value === 'week' ? labels.week : labels.day; weekdayHeading.hidden=intervalInput.value !== 'day'; status.textContent=activeRecords.length ? `${selectedGroupLabel} · ${storeCount} ${labels.storeRecords}` : labels.noData; kpis.innerHTML=[[labels.netRevenue,dkk.format(total.net_revenue_dkk)],[labels.grossUnits,number.format(total.eligible_units)],[labels.netUnits,number.format(total.net_units)],[labels.codeUseRate,percent(rate)]].map(([label,value]) => `<article class="promotion-performance-dashboard__kpi"><span>${escape(label)}</span><strong>${escape(value)}</strong></article>`).join(''); const max=Math.max(...periodRows.map((row) => metric.value(visibleMetrics(row))),1); chart.innerHTML=periodRows.map((row) => { const segments=row.series.filter((series) => !hiddenSeriesKeys.has(series.promotion.key || series.promotion.handle) && metric.value(series.metrics) > 0); return `<div class="promotion-performance-dashboard__bar"><span>${escape(metric.format(metric.value(visibleMetrics(row))))}</span><div class="promotion-performance-dashboard__bar-stack">${segments.map((series) => { const seriesRate=series.metrics.eligible_units ? series.metrics.units_with_promotion_code / series.metrics.eligible_units * 100 : 0; const seriesName=promotionName(series.promotion,groupInput.value === 'all'); const value=metric.value(series.metrics); return `<button type="button" class="promotion-performance-dashboard__bar-segment" data-chart-segment data-series-key="${escape(series.promotion.key || series.promotion.handle)}" data-promotion="${escape(seriesName)}" data-period="${escape(periodLabel(row.key))}" data-value="${escape(metric.format(value))}" data-revenue="${escape(dkk.format(series.metrics.net_revenue_dkk))}" data-units="${escape(number.format(series.metrics.eligible_units))}" data-code-units="${escape(number.format(series.metrics.units_with_promotion_code))}" data-rate="${escape(percent(seriesRate))}" aria-label="${escape(`${seriesName}, ${periodLabel(row.key)}, ${metric.label}: ${metric.format(value)}`)}" style="height:${Math.max(3,value/max*100)}%;background:${colourByPromotion.get(series.promotion.key) || promotionColour(series.promotion)}"></button>`; }).join('')}</div><span>${escape(periodLabel(row.key))}</span></div>`; }).join(''); chartLegend.innerHTML=promotionRows.map((row) => { const seriesKey=row.promotion.key; const visible=!hiddenSeriesKeys.has(seriesKey); return `<button type="button" data-chart-legend-item data-series-key="${escape(seriesKey)}" aria-pressed="${visible}" title="${escape(promotionName(row.promotion,groupInput.value === 'all'))}"><i style="--legend-color:${colourByPromotion.get(seriesKey)}"></i><span class="promotion-performance-dashboard__legend-name">${escape(promotionName(row.promotion,groupInput.value === 'all'))}</span><span>${escape(dkk.format(row.metrics.net_revenue_dkk))}</span></button>`; }).join(''); periodsBody.innerHTML=periodRows.map((row) => { const metrics=row.metrics; const value=metrics.eligible_units ? metrics.units_with_promotion_code/metrics.eligible_units*100 : 0; return `<tr><td>${escape(intervalInput.value === 'month' ? monthLabel(row.key) : row.key)}</td>${intervalInput.value === 'day' ? `<td>${escape(weekday(row.key))}</td>` : ''}<td>${number.format(metrics.eligible_units)}</td><td>${dkk.format(metrics.net_revenue_dkk)}</td><td>${percent(value)}</td></tr>`; }).join(''); storesBody.innerHTML=storeRows.map((row) => { const metrics=row.metrics; const value=metrics.eligible_units ? metrics.units_with_promotion_code/metrics.eligible_units*100 : 0; return `<tr><td>${escape(row.store)}</td><td>${number.format(metrics.eligible_units)}</td><td>${dkk.format(metrics.net_revenue_dkk)}</td><td>${percent(value)}</td></tr>`; }).join(''); groupsBody.innerHTML=groupRows.map((row) => { const share=total.net_revenue_dkk ? row.metrics.net_revenue_dkk/total.net_revenue_dkk*100 : 0; return `<tr><td>${escape(row.label)}</td><td>${escape(scheduleLabel(row.schedule))}</td><td>${number.format(row.metrics.eligible_units)}</td><td>${dkk.format(row.metrics.net_revenue_dkk)}</td><td>${percent(share)}</td></tr>`; }).join(''); promotionsBody.innerHTML=promotionRows.map((row) => { const metrics=row.metrics; const value=metrics.eligible_units ? metrics.units_with_promotion_code/metrics.eligible_units*100 : 0; return `<tr><td>${escape(promotionItemName(row.promotion))}</td><td>${escape(promotionId(row.promotion) || '—')}</td><td>${escape(row.promotion.discount_code || '—')}</td><td>${number.format(metrics.eligible_units)}</td><td>${number.format(metrics.units_with_promotion_code)}</td><td>${percent(value)}</td><td>${dkk.format(metrics.net_revenue_dkk)}</td><td>${percent(total.net_revenue_dkk ? metrics.net_revenue_dkk / total.net_revenue_dkk * 100 : 0)}</td></tr>`; }).join(''); };
    groupInput.innerHTML = `<option value="all">${escape(labels.allGroups)}</option>${groups.map((entry) => `<option value="${escape(entry.handle)}">${escape(entry.label)}</option>`).join('')}`; groupInput.value=groups[0].handle; populateInteractive(); [groupInput,promotionInput,storeInput,fromInput,toInput,intervalInput,chartMetricInput].forEach((input) => input.addEventListener('change',() => { if (input === groupInput) populateInteractive(); renderInteractive(); })); renderInteractive();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-categories-popup"] && !Shopify.designMode) return;
  try {
    
  const RelatedCategoriesBaseDialog = customElements.get('dialog-element');

  if (RelatedCategoriesBaseDialog && !customElements.get('related-categories-dialog')) {
    class RelatedCategoriesDialog extends RelatedCategoriesBaseDialog {
      constructor() {
        super();
        this.activeIndex = -1;
        this.autoOpenQuickBuy = false;
        this.categories = [];
        this.limit = 8;
        this.dialogInitialCount = 12;
        this.pageSize = 24;
        this.loadMoreThreshold = 560;
        this.productCache = new Map();
        this.strings = {};
        this.filterState = {
          query: '',
          sort: 'featured'
        };
        this.cartState = null;
        this.cartLinesByVariant = new Map();
        this.cartLinesByProduct = new Map();
        this._continueButtonInlineStyle = '';
        this.searchDebounceMs = 700;
        this.quantityDebounceMs = 300;
        this._filterRequestToken = 0;
        this._cardMarkupRenderCount = 0;
        this._activeAbortController = null;
        this._quantityUpdateStates = new Map();
        this._onBackdropClick = this._onBackdropClick.bind(this);
        this._onCloseActionClick = this._onCloseActionClick.bind(this);
        this._onNavClick = this._onNavClick.bind(this);
        this._onDialogClick = this._onDialogClick.bind(this);
        this._onGridScroll = this._onGridScroll.bind(this);
        this._onFilterInput = this._onFilterInput.bind(this);
        this._onCartChange = this._onCartChange.bind(this);
        this._onCartRefresh = this._onCartRefresh.bind(this);
        this._onQuantityInputChange = this._onQuantityInputChange.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-modal', 'true');
        this.backdrop = this.querySelector('.related-categories-dialog__backdrop');
        this.titleElement = this.querySelector('[data-related-categories-current-title]');
        this.navElement = this.querySelector('[data-related-categories-nav]');
        this.contentElement = this.querySelector('.related-categories-dialog__content');
        this.filtersElement = this.querySelector('[data-related-categories-filters]');
        this.statusElement = this.querySelector('[data-related-categories-status]');
        this.gridElement = this.querySelector('[data-related-categories-grid]');
        this.closeActionButton = this.querySelector('[data-related-categories-close-button]');
        this.closeActionLabel = this.querySelector('[data-related-categories-close-label]');
        this.defaultCloseLabel = this.closeActionButton?.getAttribute('aria-label') || '';
        this.searchInput = this.querySelector('[data-related-categories-filter-search]');
        this.sortSelect = this.querySelector('[data-related-categories-filter-sort]');
        this.backdrop?.addEventListener('click', this._onBackdropClick);
        this.closeActionButton?.addEventListener('click', this._onCloseActionClick);
        this.navElement?.addEventListener('click', this._onNavClick);
        this.addEventListener('click', this._onDialogClick);
        this.gridElement?.addEventListener('scroll', this._onGridScroll, { passive: true });
        this.searchInput?.addEventListener('input', this._onFilterInput);
        this.sortSelect?.addEventListener('change', this._onFilterInput);
        this.addEventListener('change', this._onQuantityInputChange);
        document.documentElement.addEventListener('cart:change', this._onCartChange);
        document.addEventListener('cart:refresh', this._onCartRefresh);
        this._captureAtcButtonPalette();
        this._hydrateCartState();
        this.setCloseMode('close');
      }

      disconnectedCallback() {
        this.backdrop?.removeEventListener('click', this._onBackdropClick);
        this.closeActionButton?.removeEventListener('click', this._onCloseActionClick);
        this.navElement?.removeEventListener('click', this._onNavClick);
        this.removeEventListener('click', this._onDialogClick);
        this.gridElement?.removeEventListener('scroll', this._onGridScroll);
        this.searchInput?.removeEventListener('input', this._onFilterInput);
        this.sortSelect?.removeEventListener('change', this._onFilterInput);
        this.removeEventListener('change', this._onQuantityInputChange);
        document.documentElement.removeEventListener('cart:change', this._onCartChange);
        document.removeEventListener('cart:refresh', this._onCartRefresh);
        window.clearTimeout(this._searchDebounceTimeout);
        window.clearTimeout(this._cartDrawerOpenTimeout);
        this._clearQueuedQuantityUpdates();
        this._abortActiveRequests();
        this._releasePinnedCartDrawer();
        this._cancelPrefetch();
        super.disconnectedCallback();
      }

      get shouldLock() {
        return true;
      }

      get shouldAppendToBody() {
        return true;
      }

      get initialFocus() {
        return this.querySelector('[data-related-categories-close-button]') || this.querySelector('.related-categories-dialog__nav-button') || this;
      }

      configure({ categories, productId, limit, strings }) {
        this.categories = Array.isArray(categories) ? categories.filter((category) => category.handle) : [];
        this.productId = Number(productId || 0);
        this.limit = Number(limit || 8);
        this.dialogInitialCount = Math.max(this.limit, 12);
        this.pageSize = Math.max(this.limit * 3, 24);
        this.strings = strings || {};
        this.productCache = new Map();
        this._seedPreloadedProducts();
        this._renderNav();
        this.setCloseMode('close');
      }

      getCategory(index) {
        return this.categories[index] || null;
      }

      getCachedProducts(index) {
        const category = this.getCategory(index);
        return category ? this.productCache.get(category.handle)?.products || [] : [];
      }

      getCategorySummary(index) {
        const category = this.getCategory(index);
        const state = category ? this._getCategoryState(category) : null;

        return {
          totalCount: Number(category?.totalCount || state?.totalCount || 0),
          cachedCount: Number(state?.products?.length || 0),
          hasMore: Boolean(state?.hasMore)
        };
      }

      formatViewAll(title) {
        return this._interpolate(this.strings.view_all, { title });
      }

      setCloseMode(mode = 'close') {
        const requestedMode = mode === 'continue' ? 'continue' : 'close';
        this.closeMode = requestedMode === 'close' && this._continueToCartModeLocked && this.hasAttribute('open') ? 'continue' : requestedMode;

        if (!(this.closeActionButton instanceof HTMLButtonElement)) {
          return;
        }

        const isContinueMode = this.closeMode === 'continue';
        const continueLabel = this._getContinueToCartLabel();
        this.closeActionButton.dataset.mode = this.closeMode;
        this.closeActionButton.setAttribute('aria-label', isContinueMode ? (this.strings.continue_to_cart || continueLabel || '') : this.defaultCloseLabel);

        if (this.closeActionLabel) {
          this.closeActionLabel.textContent = isContinueMode ? continueLabel : '';
        }

        if (isContinueMode && this._continueButtonInlineStyle) {
          this.closeActionButton.setAttribute('style', this._continueButtonInlineStyle);
        } else {
          this.closeActionButton.removeAttribute('style');
        }

        if (!isContinueMode) {
          this._releasePinnedCartDrawer();
        }
      }

      _lockContinueToCartMode() {
        this._continueToCartModeLocked = true;
        this.setCloseMode('continue');
      }

      _unlockContinueToCartMode() {
        this._continueToCartModeLocked = false;
        this.setCloseMode('close');
      }

      _getContinueToCartLabel() {
        const isCompactViewport = window.matchMedia('(max-width: 699px)').matches;

        if (isCompactViewport) {
          return this.strings.continue_short || this.strings.continue_to_cart || '';
        }

        return this.strings.continue_to_cart || this.strings.continue_short || '';
      }

      _syncFilterStateFromInputs() {
        this.filterState = {
          query: this.searchInput?.value || '',
          sort: this.sortSelect?.value || 'featured'
        };
      }

      _setSearchPending(isPending) {
        this._isSearchPending = Boolean(isPending);
        this.gridElement?.setAttribute('aria-busy', this._isSearchPending ? 'true' : 'false');
      }

      _createActiveRequestSignal() {
        this._abortActiveRequests();
        this._activeAbortController = new AbortController();
        return this._activeAbortController.signal;
      }

      _abortActiveRequests() {
        if (this._activeAbortController) {
          this._activeAbortController.abort();
          this._activeAbortController = null;
        }
      }

      _onFilterInput(event) {
        this._syncFilterStateFromInputs();

        const isSearchInput = event?.target === this.searchInput;
        this._scheduleFilterRender({ debounce: isSearchInput });
      }

      _scheduleFilterRender(options = {}) {
        const shouldDebounce = Boolean(options.debounce && this._collapseWhitespace(this.filterState.query));
        const requestToken = ++this._filterRequestToken;
        const runFilterRender = () => {
          this._runFilterRender(requestToken);
        };

        window.clearTimeout(this._searchDebounceTimeout);

        if (shouldDebounce) {
          this._abortActiveRequests();
          this._setSearchPending(true);
          this._renderStatus(this.strings.loading);
          this._searchDebounceTimeout = window.setTimeout(runFilterRender, this.searchDebounceMs);
          return;
        }

        runFilterRender();
      }

      async _runFilterRender(requestToken = ++this._filterRequestToken) {
        const category = this.getCategory(this.activeIndex);
        const signal = this._createActiveRequestSignal();

        if (!category) {
          this._setSearchPending(false);
          return;
        }

        try {
          const normalizedQuery = this._collapseWhitespace(this.filterState.query);

          if (normalizedQuery) {
            this._setSearchPending(true);
            this._renderStatus(this.strings.loading);
            await this._ensureSearchCoverageForActiveCategory({ requestToken, categoryHandle: category.handle, signal });

            if (requestToken !== this._filterRequestToken || this.getCategory(this.activeIndex)?.handle !== category.handle) {
              return;
            }
          }

          this._renderActiveProducts();
        } catch (error) {
          if (error?.name === 'AbortError') {
            return;
          }

          if (requestToken === this._filterRequestToken && this.getCategory(this.activeIndex)?.handle === category.handle) {
            console.error(`[related-categories-popup] filter render failed | category=${category.handle} | page=${window.location.href} | error=${error?.message || error}`);
            this._renderStatus(this.strings.error);
          }
        } finally {
          if (requestToken === this._filterRequestToken && this.getCategory(this.activeIndex)?.handle === category.handle) {
            this._setSearchPending(false);
          }
        }
      }

      _onCartChange(event) {
        if (event.detail?.cart) {
          this._setCartState(event.detail.cart);
        }
      }

      async _onCartRefresh() {
        await this._hydrateCartState();
      }

      _onQuantityInputChange(event) {
        const input = event.target;

        if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-related-categories-line-key')) {
          return;
        }

        const lineKey = input.getAttribute('data-related-categories-line-key');
        const quantity = Math.max(0, Number(input.value || 0));

        if (!lineKey || Number.isNaN(quantity)) {
          return;
        }

        this._queueLineItemQuantityChange(lineKey, quantity, input);
      }

      async _hydrateCartState() {
        if (this._cartHydrationPromise) {
          return this._cartHydrationPromise;
        }

        this._cartHydrationPromise = (async () => {
          try {
            const response = await fetch(`${Shopify.routes.root}cart.js`, { credentials: 'same-origin' });

            if (!response.ok) {
              return;
            }

            this._setCartState(await response.json());
          } catch (error) {
            return;
          } finally {
            this._cartHydrationPromise = null;
          }
        })();

        return this._cartHydrationPromise;
      }

      _setCartState(cart, options = {}) {
        this.cartState = cart || null;
        this.cartLinesByVariant = new Map();
        this.cartLinesByProduct = new Map();

        if (Array.isArray(cart?.items)) {
          cart.items.forEach((lineItem) => {
            const variantId = Number(lineItem?.variant_id || lineItem?.id || 0);
            const productId = Number(lineItem?.product_id || 0);

            if (!variantId) {
              this._accumulateCartLineSummary(this.cartLinesByProduct, productId, lineItem);
              return;
            }

            this._accumulateCartLineSummary(this.cartLinesByVariant, variantId, lineItem);
            this._accumulateCartLineSummary(this.cartLinesByProduct, productId, lineItem);
          });
        }

        if (options.syncCards !== false) {
          this._syncRenderedCardCtas(this.gridElement);
        }
      }

      _accumulateCartLineSummary(summaryMap, identifier, lineItem) {
        const normalizedIdentifier = Number(identifier || 0);

        if (!normalizedIdentifier) {
          return;
        }

        const existingLine = summaryMap.get(normalizedIdentifier);

        if (existingLine) {
          // Shared variants can appear on multiple cart lines when properties or bundle context differ.
          existingLine.quantity += Number(lineItem?.quantity || 0);
          existingLine.lineCount += 1;
          existingLine.key = null;
          return;
        }

        summaryMap.set(normalizedIdentifier, {
          key: lineItem?.key || null,
          quantity: Number(lineItem?.quantity || 0),
          lineCount: 1
        });
      }

      _getCartLineForVariant(variantId) {
        return this.cartLinesByVariant.get(Number(variantId || 0)) || null;
      }

      _getCartLineForProduct(productId) {
        return this.cartLinesByProduct.get(Number(productId || 0)) || null;
      }

      _queueLineItemQuantityChange(lineKey, quantity, input) {
        const selector = input.closest('.related-categories-dialog__quantity-selector');
        const existingState = this._quantityUpdateStates.get(lineKey) || {};

        window.clearTimeout(existingState.timer);

        const state = {
          ...existingState,
          input,
          selector,
          quantity
        };

        selector?.setAttribute('data-related-categories-quantity-pending', 'true');

        if (state.inFlight) {
          state.needsFlush = true;
          this._quantityUpdateStates.set(lineKey, state);
          return;
        }

        state.timer = window.setTimeout(() => {
          this._flushLineItemQuantityChange(lineKey);
        }, this.quantityDebounceMs);

        this._quantityUpdateStates.set(lineKey, state);
      }

      async _flushLineItemQuantityChange(lineKey) {
        const state = this._quantityUpdateStates.get(lineKey);

        if (!state || state.inFlight) {
          return;
        }

        window.clearTimeout(state.timer);
        state.timer = null;
        state.inFlight = true;
        state.needsFlush = false;
        this._quantityUpdateStates.set(lineKey, state);

        const requestedQuantity = state.quantity;

        try {
          await this._changeLineItemQuantity(lineKey, requestedQuantity);
        } finally {
          const latestState = this._quantityUpdateStates.get(lineKey);

          if (!latestState) {
            return;
          }

          latestState.inFlight = false;

          if (latestState.needsFlush || latestState.quantity !== requestedQuantity) {
            latestState.timer = window.setTimeout(() => {
              this._flushLineItemQuantityChange(lineKey);
            }, this.quantityDebounceMs);
            this._quantityUpdateStates.set(lineKey, latestState);
            return;
          }

          latestState.selector?.removeAttribute('data-related-categories-quantity-pending');
          this._quantityUpdateStates.delete(lineKey);
        }
      }

      _clearQueuedQuantityUpdates() {
        this._quantityUpdateStates.forEach((state) => {
          window.clearTimeout(state.timer);
          state.selector?.removeAttribute('data-related-categories-quantity-pending');
        });
        this._quantityUpdateStates.clear();
      }

      async _changeLineItemQuantity(lineKey, quantity) {
        if (!lineKey) {
          return;
        }

        try {
          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: {
              sections: sectionsToBundle
            }
          }));

          const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: lineKey,
              quantity,
              sections: sectionsToBundle
            })
          });

          if (!response.ok) {
            throw new Error(`Quantity update failed with status ${response.status}`);
          }

          const cartContent = await response.json();
          const queuedState = this._quantityUpdateStates.get(lineKey);
          const shouldDeferRender = Boolean(queuedState && (queuedState.needsFlush || queuedState.quantity !== quantity));

          this._setCartState(cartContent, { syncCards: !shouldDeferRender });

          if (!shouldDeferRender) {
            if (cartContent?.sections && Object.keys(cartContent.sections).length > 0) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'related-categories:quantity-change',
                  cart: cartContent
                }
              }));
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }
          }
        } catch (error) {
          await this._hydrateCartState();
          this._syncRenderedCardCtas(this.gridElement);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      }

      setActiveCategory(index) {
        if (!Number.isInteger(index) || index < 0 || index >= this.categories.length) {
          return;
        }

        this.activeIndex = index;
        window.clearTimeout(this._searchDebounceTimeout);
        this._filterRequestToken += 1;
        this._setSearchPending(false);
        this._lastGridScrollTop = 0;
        this._setFiltersHidden(false);
        if (this.gridElement) {
          this.gridElement.scrollTop = 0;
        }
        this._syncNav();
        this.dispatchEvent(new CustomEvent('related-categories:change', { detail: { index }, bubbles: true }));
        this._loadActiveCategory();
      }

      async ensureCategoryProducts(index, options = {}) {
        const category = this.getCategory(index);

        if (!category) {
          return [];
        }

        const state = this._getCategoryState(category);
        const requestedMinimum = Number(options.minimum || this.limit) || this.limit;
        const minimumCount = Math.max(this.limit, requestedMinimum);

        while (state.products.length < minimumCount && state.hasMore) {
          await this._loadNextCategoryBatch(category, state, options);
        }

        return state.products;
      }

      async loadMoreCategoryProducts(index, options = {}) {
        const category = this.getCategory(index);

        if (!category) {
          return { previousCount: 0, products: [] };
        }

        const state = this._getCategoryState(category);
        const previousCount = state.products.length;

        if (state.hasMore) {
          await this._loadNextCategoryBatch(category, state, options);
        }

        return {
          previousCount,
          products: state.products
        };
      }

      buildProductMarkup(products, scope = 'dialog') {
        const renderKey = `${scope}-${++this._cardMarkupRenderCount}`;

        return products.map((product, index) => this._buildProductCard(product, index, scope, renderKey)).join('');
      }

      _getCategoryState(category) {
        if (!category?.handle) {
          return null;
        }

        if (!this.productCache.has(category.handle)) {
          this.productCache.set(category.handle, {
            mode: null,
            nextPage: 1,
            hasMore: true,
            loadingPromise: null,
            products: [],
            seenProductIds: new Set(),
            totalCount: Number(category.totalCount || 0)
          });
        }

        const state = this.productCache.get(category.handle);

        if (Number(category.totalCount || 0) > 0) {
          state.totalCount = Number(category.totalCount || 0);
        }

        return state;
      }

      async _loadNextCategoryBatch(category, state, options = {}) {
        if (!category || !state?.hasMore) {
          return state?.products || [];
        }

        if (state.loadingPromise) {
          return state.loadingPromise;
        }

        state.loadingPromise = (async () => {
          if (!state.mode) {
            const nativeResult = await this._tryFetchCollectionPageBatch(category, state, options);

            if (nativeResult) {
              this._appendCategoryBatch(state, nativeResult, 'html');
              return state.products;
            }

            const jsonResult = await this._fetchCategoryProductsFromJsonPage(category, state.seenProductIds, state.nextPage, this.pageSize, options);

            if (jsonResult.products.length === 0 && !jsonResult.hasMore) {
              state.hasMore = false;
              throw new Error(`Related categories load failed for ${category.handle}`);
            }

            this._appendCategoryBatch(state, jsonResult, 'json');
            return state.products;
          }

          if (state.mode === 'html' || state.mode === 'section') {
            const nativeResult = state.mode === 'section'
              ? await this._fetchCategoryProductsFromCollectionSection(category, state.seenProductIds, state.nextPage, options)
              : await this._fetchCategoryProductsFromCollectionPage(category, state.seenProductIds, state.nextPage, options);

            if (nativeResult.products.length === 0 && !nativeResult.hasMore) {
              state.hasMore = false;
              return state.products;
            }

            this._appendCategoryBatch(state, nativeResult, 'html');
            return state.products;
          }

          const jsonResult = await this._fetchCategoryProductsFromJsonPage(category, state.seenProductIds, state.nextPage, this.pageSize, options);

          if (jsonResult.products.length === 0 && !jsonResult.hasMore) {
            state.hasMore = false;
            return state.products;
          }

          this._appendCategoryBatch(state, jsonResult, 'json');
          return state.products;
        })().finally(() => {
          state.loadingPromise = null;
        });

        return state.loadingPromise;
      }

      _appendCategoryBatch(state, batch, mode) {
        state.mode = mode;
        state.nextPage += 1;
        state.hasMore = Boolean(batch?.hasMore);

        if (Array.isArray(batch?.products) && batch.products.length > 0) {
          state.products.push(...batch.products);
        }
      }

      async _tryFetchCollectionPageBatch(category, state, options = {}) {
        try {
          const nativeResult = options.useSectionRendering
            ? await this._fetchCategoryProductsFromCollectionSection(category, state.seenProductIds, state.nextPage, options)
            : await this._fetchCategoryProductsFromCollectionPage(category, state.seenProductIds, state.nextPage, options);

          if (nativeResult.products.length > 0 || nativeResult.hasMore) {
            return nativeResult;
          }
        } catch (error) {
          if (error?.name === 'AbortError') {
            throw error;
          }

          state.htmlFailure = error?.message || String(error);
        }

        return null;
      }

      hide() {
        window.clearTimeout(this._searchDebounceTimeout);
        this._setSearchPending(false);
        this._continueToCartModeLocked = false;

        const result = super.hide();

        if (result && typeof result.finally === 'function') {
          return result.finally(() => {
            this.setCloseMode('close');
            this._releasePinnedCartDrawer();
          });
        }

        this.setCloseMode('close');
        this._releasePinnedCartDrawer();
        return result;
      }

      show(animate = true) {
        if (this.activeIndex === -1 && this.categories.length > 0) {
          this.activeIndex = 0;
          this._syncNav();
        }

        if (this.activeIndex > -1) {
          this._loadActiveCategory();
        }

        const result = super.show(animate);

        if (this.autoOpenQuickBuy) {
          requestAnimationFrame(() => this._focusFirstPurchaseAction());
        }

        return result;
      }

      showCategory(index, options = {}) {
        const normalizedIndex = Number.isInteger(index) && index >= 0 ? index : 0;
        const shouldContinueToCart = Boolean(options.continueToCart);

        this.autoOpenQuickBuy = options.autoOpenQuickBuy !== false;
        this._lastGridScrollTop = 0;
        this._setFiltersHidden(false);

        if (shouldContinueToCart) {
          this._lockContinueToCartMode();
        } else {
          this._unlockContinueToCartMode();
        }

        this.setActiveCategory(normalizedIndex);
        this.show();

        if (shouldContinueToCart) {
          requestAnimationFrame(() => this.setCloseMode('continue'));
          window.setTimeout(() => this.setCloseMode('continue'), 700);
        }
      }

      _seedPreloadedProducts() {
        this.categories.forEach((category, categoryIndex) => {
          if (!Array.isArray(category?.preloadedProducts) || category.preloadedProducts.length === 0) {
            return;
          }

          const state = this._getCategoryState(category);
          const normalizedProducts = category.preloadedProducts
            .map((product, productIndex) => {
              const productId = Number(product?.id || 0);
              const normalizedMarkup = this._normalizePreloadedProductMarkup(product?.markup, productId, category.handle || `preloaded-${categoryIndex}`, productIndex);

              if (!normalizedMarkup) {
                return null;
              }

              const wrapper = document.createElement('div');
              wrapper.innerHTML = normalizedMarkup;
              const normalizedCard = wrapper.firstElementChild;
              const extractedProduct = normalizedCard instanceof Element ? this._extractCollectionCardData(normalizedCard) : {};

              return {
                ...extractedProduct,
                id: productId || Number(extractedProduct?.id || 0),
                __htmlMarkup: normalizedMarkup
              };
            })
            .filter(Boolean);

          state.mode = 'preloaded';
          state.nextPage = 1;
          state.totalCount = Number(category.totalCount || normalizedProducts.length || 0);
          state.hasMore = state.totalCount > normalizedProducts.length;
          state.products = normalizedProducts;
          state.seenProductIds = new Set(normalizedProducts.map((product) => Number(product.id || 0)).filter(Boolean));
        });
      }

      prefetchCategories(startIndex = 0) {
        this._schedulePrefetch(startIndex);
      }

      _onGridScroll() {
        if (!this.hasAttribute('open') || !this.gridElement || this.activeIndex < 0) {
          return;
        }

        const currentScroll = Math.max(0, this.gridElement.scrollTop);
        const previousScroll = Number(this._lastGridScrollTop || 0);
        const scrollDelta = currentScroll - previousScroll;

        if (scrollDelta > 16 && currentScroll > 120) {
          this._setFiltersHidden(true);
        } else if (scrollDelta < -16 || currentScroll < 48) {
          this._setFiltersHidden(false);
        }

        this._lastGridScrollTop = currentScroll;

        const remainingScroll = this.gridElement.scrollHeight - currentScroll - this.gridElement.clientHeight;

        if (remainingScroll > this.loadMoreThreshold) {
          return;
        }

        this._loadMoreForActiveCategory();
      }

      _onBackdropClick() {
        this.hide();
      }

      _onCloseActionClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.closeMode === 'continue') {
          Promise.resolve(this.hide()).finally(() => {
            this._openCartDrawer();
          });
          return;
        }

        this.hide();
      }

      _onNavClick(event) {
        const button = event.target.closest('[data-related-categories-nav-index]');

        if (!button) {
          return;
        }

        this.setActiveCategory(Number(button.dataset.relatedCategoriesNavIndex || 0));
      }

      _onDialogClick(event) {
        const target = event.target;

        if (!(target instanceof Element)) {
          return;
        }

        const openCartButton = target.closest('[data-related-categories-open-cart]');

        if (!openCartButton || !this.contains(openCartButton)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        Promise.resolve(this.hide()).finally(() => {
          this._openCartDrawer();
        });
      }

      _renderNav() {
        if (!this.navElement) {
          return;
        }

        this.navElement.innerHTML = this.categories
          .map((category, index) => {
            const isActive = index === this.activeIndex;
            const thumbnailMarkup = category.image
              ? `
                <span class="related-categories-dialog__nav-thumb">
                  <img src="${this._escapeAttribute(category.image)}" alt="" loading="lazy" width="48" height="48">
                </span>
              `
              : `
                <span class="related-categories-dialog__nav-placeholder">
                  ${this._escapeHtml(String(category.title || '').slice(0, 1))}
                </span>
              `;

            return `
              <button
                type="button"
                class="related-categories-dialog__nav-button"
                data-related-categories-nav-index="${index}"
                aria-pressed="${isActive ? 'true' : 'false'}"
              >
                ${thumbnailMarkup}
                <span class="related-categories-dialog__nav-title">${this._escapeHtml(category.title)}</span>
              </button>
            `;
          })
          .join('');

        if (this.activeIndex === -1 && this.categories.length > 0) {
          this.activeIndex = 0;
        }

        this._syncNav();
      }

      _syncNav() {
        this.navElement?.querySelectorAll('[data-related-categories-nav-index]').forEach((button) => {
          const buttonIndex = Number(button.dataset.relatedCategoriesNavIndex || 0);
          button.setAttribute('aria-pressed', buttonIndex === this.activeIndex ? 'true' : 'false');
        });
      }

      _hasActiveFilters() {
        return Boolean(this.filterState.query.trim() || this.filterState.sort !== 'featured');
      }

      _getFilteredProducts(products) {
        const normalizedProducts = Array.isArray(products) ? [...products] : [];
        const query = this._collapseWhitespace(this.filterState.query).toLowerCase();
        let filteredProducts = normalizedProducts;

        if (query) {
          filteredProducts = filteredProducts.filter((product) => this._getProductSearchText(product).includes(query));
        }

        switch (this.filterState.sort) {
          case 'price-asc':
            filteredProducts.sort((productA, productB) => this._getProductPriceValue(productA) - this._getProductPriceValue(productB));
            break;
          case 'price-desc':
            filteredProducts.sort((productA, productB) => this._getProductPriceValue(productB) - this._getProductPriceValue(productA));
            break;
          case 'title-asc':
            filteredProducts.sort((productA, productB) => String(productA?.title || '').localeCompare(String(productB?.title || ''), undefined, { sensitivity: 'base' }));
            break;
          default:
            break;
        }

        return filteredProducts;
      }

      _getProductPriceValue(product) {
        const numericPrice = Number(product?.priceValue ?? product?.price);

        if (Number.isFinite(numericPrice) && numericPrice > 0) {
          return numericPrice;
        }

        const parsedTextPrice = this._parseMoneyString(product?.priceText);
        return Number.isFinite(parsedTextPrice) ? parsedTextPrice : Number.MAX_SAFE_INTEGER;
      }

      _getProductSearchText(product) {
        if (!product) {
          return '';
        }

        if (!product.__searchText) {
          product.__searchText = this._collapseWhitespace([
            product.title,
            product.handle,
            product.vendor,
            product.type,
            product.priceText
          ].filter(Boolean).join(' ')).toLowerCase();
        }

        return product.__searchText;
      }

      _parseMoneyString(value) {
        const normalizedValue = String(value || '').replace(/[^\d,.-]/g, '');

        if (!normalizedValue) {
          return Number.NaN;
        }

        const lastCommaIndex = normalizedValue.lastIndexOf(',');
        const lastDotIndex = normalizedValue.lastIndexOf('.');
        let decimalNormalizedValue = normalizedValue;

        if (lastCommaIndex > lastDotIndex) {
          decimalNormalizedValue = normalizedValue.replace(/\./g, '').replace(',', '.');
        } else {
          decimalNormalizedValue = normalizedValue.replace(/,/g, '');
        }

        return parseFloat(decimalNormalizedValue);
      }

      _renderActiveProducts() {
        const category = this.getCategory(this.activeIndex);
        const state = this._getCategoryState(category);
        const sourceProducts = state?.products || [];
        const filteredProducts = this._getFilteredProducts(sourceProducts);

        this._renderProducts(filteredProducts, { sourceCount: sourceProducts.length });
      }

      async _ensureSearchCoverageForActiveCategory(options = {}) {
        const normalizedQuery = this._collapseWhitespace(this.filterState.query);
        const requestToken = Number(options.requestToken || 0);

        if (!normalizedQuery || this.activeIndex < 0) {
          return;
        }

        const category = this.getCategory(this.activeIndex);
        const state = this._getCategoryState(category);
        const expectedHandle = options.categoryHandle || category?.handle || '';

        if (!category || !state?.hasMore) {
          return;
        }

        const minimumMatches = Math.max(this.limit, 12);
        let filteredProducts = this._getFilteredProducts(state.products);
        let safetyCounter = 0;

        while (state.hasMore && filteredProducts.length < minimumMatches && safetyCounter < 6) {
          if (requestToken && requestToken !== this._filterRequestToken) {
            return;
          }

          const previousCount = state.products.length;
          const { products } = await this.loadMoreCategoryProducts(this.activeIndex, { signal: options.signal });

          if (this.getCategory(this.activeIndex)?.handle !== expectedHandle || products.length === previousCount) {
            break;
          }

          filteredProducts = this._getFilteredProducts(products);
          safetyCounter += 1;
        }
      }

      async _loadActiveCategory() {
        const category = this.getCategory(this.activeIndex);
        const signal = this._createActiveRequestSignal();

        if (!category) {
          return;
        }

        if (this.titleElement) {
          this.titleElement.textContent = category.title;
        }

        const state = this._getCategoryState(category);

        if (state.products.length > 0) {
          if (this.filterState.query.trim()) {
            this._scheduleFilterRender({ debounce: false });
          } else {
            this._renderActiveProducts();
          }
          this._schedulePrefetch(this.activeIndex);
          return;
        }

        this._renderStatus(this.strings.loading);
        this._clearGrid();

        try {
          const products = await this.ensureCategoryProducts(this.activeIndex, { minimum: this.dialogInitialCount, signal });

          if (this.getCategory(this.activeIndex)?.handle === category.handle) {
            if (this.filterState.query.trim()) {
              this._scheduleFilterRender({ debounce: false });
            } else {
              this._renderProducts(this._getFilteredProducts(products), { sourceCount: products.length });
            }
            this._schedulePrefetch(this.activeIndex);
          }
        } catch (error) {
          if (error?.name === 'AbortError') {
            return;
          }

          if (this.getCategory(this.activeIndex)?.handle === category.handle) {
            this.autoOpenQuickBuy = false;
            console.error(`[related-categories-popup] dialog load failed | category=${category.handle} | collection=${category.url} | page=${window.location.href} | error=${error?.message || error}`);
            this._renderStatus(this.strings.error);
          }
        }
      }

      async _loadMoreForActiveCategory() {
        if (this._isLoadingMore || this.activeIndex < 0) {
          return;
        }

        const category = this.getCategory(this.activeIndex);
        const state = this._getCategoryState(category);

        if (!category || !state?.hasMore) {
          return;
        }

        this._isLoadingMore = true;
        this._setLoadingMore(true);

        try {
          const { previousCount, products } = await this.loadMoreCategoryProducts(this.activeIndex);

          if (this.getCategory(this.activeIndex)?.handle !== category.handle) {
            return;
          }

          const appendedProducts = products.slice(previousCount);

          if (appendedProducts.length > 0 && !this._hasActiveFilters()) {
            this._appendProducts(appendedProducts);
          } else {
            this._renderActiveProducts();
          }
        } catch (error) {
          console.error(`[related-categories-popup] dialog append failed | category=${category.handle} | collection=${category.url} | page=${window.location.href} | error=${error?.message || error}`);
        } finally {
          this._isLoadingMore = false;
          this._setLoadingMore(false);
        }
      }

      _schedulePrefetch(activeIndex) {
        this._cancelPrefetch();

        const idleRunner = async () => {
          this._prefetchHandle = null;
          const indexes = this._getPrefetchOrder(activeIndex);

          for (const prefetchIndex of indexes) {
            if (this.getCachedProducts(prefetchIndex).length > 0) {
              continue;
            }

            try {
              await this.ensureCategoryProducts(prefetchIndex, { minimum: this.limit });
            } catch (error) {
              continue;
            }

            await new Promise((resolve) => {
              window.setTimeout(resolve, 0);
            });
          }
        };

        if ('requestIdleCallback' in window) {
          this._prefetchHandle = window.requestIdleCallback(idleRunner, { timeout: 1200 });
        } else {
          this._prefetchHandle = window.setTimeout(idleRunner, 300);
        }
      }

      _cancelPrefetch() {
        if (!this._prefetchHandle) {
          return;
        }

        if ('cancelIdleCallback' in window) {
          window.cancelIdleCallback(this._prefetchHandle);
        } else {
          window.clearTimeout(this._prefetchHandle);
        }

        this._prefetchHandle = null;
      }

      _getPrefetchOrder(activeIndex) {
        const totalCategories = this.categories.length;
        const orderedIndexes = [];

        if (!totalCategories) {
          return orderedIndexes;
        }

        const normalizedIndex = Number.isInteger(activeIndex) && activeIndex >= 0 && activeIndex < totalCategories
          ? activeIndex
          : 0;

        orderedIndexes.push(normalizedIndex);
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        const isConstrainedConnection = Boolean(connection?.saveData || ['slow-2g', '2g', '3g'].includes(connection?.effectiveType));

        if (isConstrainedConnection) {
          const adjacentIndexes = [normalizedIndex + 1, normalizedIndex - 1].filter((index) => index >= 0 && index < totalCategories);
          return orderedIndexes.concat(adjacentIndexes);
        }

        for (let offset = 1; offset < totalCategories; offset += 1) {
          const forwardIndex = normalizedIndex + offset;
          const backwardIndex = normalizedIndex - offset;

          if (forwardIndex < totalCategories) {
            orderedIndexes.push(forwardIndex);
          }

          if (backwardIndex >= 0) {
            orderedIndexes.push(backwardIndex);
          }
        }

        return orderedIndexes;
      }

      async _fetchCategoryProductsFromCollectionSection(category, seenProductIds, page = 1, options = {}) {
        const failures = [];

        for (const sectionUrl of this._getCollectionSectionUrlCandidates(category, page)) {
          try {
            const response = await fetch(sectionUrl, { priority: page === 1 ? 'high' : 'low', signal: options.signal });

            if (!response.ok) {
              failures.push(`${sectionUrl} -> HTTP ${response.status}`);
              continue;
            }

            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            const primaryProductList = documentFragment.querySelector('main-collection product-list.product-list, main-collection product-list, .shopify-section--main-collection product-list.product-list, .shopify-section--main-collection product-list, product-list.product-list, product-list');
            const cards = primaryProductList
              ? Array.from(primaryProductList.querySelectorAll(':scope > product-card'))
              : Array.from(documentFragment.querySelectorAll('product-list > product-card, product-card'));
            const products = [];

            for (const card of cards) {
              const productId = Number(card.querySelector('input[name="product-id"]')?.value || 0);

              if (!productId || productId === this.productId || seenProductIds.has(productId)) {
                continue;
              }

              seenProductIds.add(productId);
              const normalizedMarkup = this._normalizeCollectionCardMarkup(card, productId, page, products.length);
              const wrapper = document.createElement('div');
              wrapper.innerHTML = normalizedMarkup;
              const normalizedCard = wrapper.firstElementChild;
              products.push({
                ...(normalizedCard instanceof Element ? this._extractCollectionCardData(normalizedCard) : {}),
                id: productId,
                __htmlMarkup: normalizedMarkup
              });
            }

            const hasMore = this._documentHasNextPage(documentFragment, page);

            if (products.length > 0 || hasMore) {
              return { products, hasMore };
            }

            failures.push(`${sectionUrl} -> no section product cards`);
          } catch (error) {
            if (error?.name === 'AbortError') {
              throw error;
            }

            failures.push(`${sectionUrl} -> ${error?.message || error}`);
          }
        }

        throw new Error(`Failed to load collection section for ${category.handle}. ${failures.join(' | ')}`);
      }

      async _fetchCategoryProductsFromCollectionPage(category, seenProductIds, page = 1, options = {}) {
        const failures = [];

        for (const collectionUrl of this._getCollectionUrlCandidates(category, page)) {
          try {
            const response = await fetch(collectionUrl, { priority: page === 1 ? 'high' : 'low', signal: options.signal });

            if (!response.ok) {
              failures.push(`${collectionUrl} -> HTTP ${response.status}`);
              continue;
            }

            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
            const primaryProductList = documentFragment.querySelector('main-collection product-list.product-list, main-collection product-list, .shopify-section--main-collection product-list.product-list, .shopify-section--main-collection product-list');
            const cards = primaryProductList
              ? Array.from(primaryProductList.querySelectorAll(':scope > product-card'))
              : Array.from(documentFragment.querySelectorAll('main-collection product-list > product-card, .shopify-section--main-collection product-list > product-card'));
            const products = [];

            for (const card of cards) {
              const productId = Number(card.querySelector('input[name="product-id"]')?.value || 0);

              if (!productId || productId === this.productId || seenProductIds.has(productId)) {
                continue;
              }

              seenProductIds.add(productId);
              const normalizedMarkup = this._normalizeCollectionCardMarkup(card, productId, page, products.length);
              const wrapper = document.createElement('div');
              wrapper.innerHTML = normalizedMarkup;
              const normalizedCard = wrapper.firstElementChild;
              products.push({
                ...(normalizedCard instanceof Element ? this._extractCollectionCardData(normalizedCard) : {}),
                id: productId,
                __htmlMarkup: normalizedMarkup
              });
            }

            const hasMore = this._documentHasNextPage(documentFragment, page);

            if (products.length > 0 || hasMore) {
              return { products, hasMore };
            }

            failures.push(`${collectionUrl} -> no native product cards`);
          } catch (error) {
            if (error?.name === 'AbortError') {
              throw error;
            }

            failures.push(`${collectionUrl} -> ${error?.message || error}`);
          }
        }

        throw new Error(`Failed to load collection page for ${category.handle}. ${failures.join(' | ')}`);
      }

      async _fetchCategoryProductsFromJsonPage(category, seenProductIds, page, pageSize = this.pageSize, options = {}) {
        let batch = null;
        const jsonFailures = [];

        for (const jsonUrl of this._getCollectionJsonUrlCandidates(category, pageSize, page)) {
          try {
            const response = await fetch(jsonUrl, { priority: page === 1 ? 'high' : 'low', signal: options.signal });

            if (!response.ok) {
              jsonFailures.push(`${jsonUrl} -> HTTP ${response.status}`);
              continue;
            }

            const payload = await response.json();

            if (Array.isArray(payload?.products)) {
              batch = payload.products;
              break;
            }

            jsonFailures.push(`${jsonUrl} -> invalid JSON payload shape`);
          } catch (error) {
            if (error?.name === 'AbortError') {
              throw error;
            }

            jsonFailures.push(`${jsonUrl} -> ${error?.message || error}`);
          }
        }

        if (!Array.isArray(batch)) {
          throw new Error(`Failed to load collection JSON for ${category.handle}. ${jsonFailures.join(' | ')}`);
        }

        const products = [];

        for (const product of batch) {
          const productId = Number(product?.id || 0);

          if (!product || !productId || productId === this.productId || seenProductIds.has(productId) || product.available === false) {
            continue;
          }

          seenProductIds.add(productId);
          products.push(product);
        }

        return {
          products,
          hasMore: batch.length >= pageSize
        };
      }

      _renderProducts(products, options = {}) {
        const sourceCount = Number(options.sourceCount || 0);

        if (!Array.isArray(products) || products.length === 0) {
          this.autoOpenQuickBuy = false;
          this._renderStatus(sourceCount > 0 ? this.strings.no_results : this.strings.empty);
          this._clearGrid();
          return;
        }

        this._renderStatus('');
        this.gridElement.innerHTML = this.buildProductMarkup(products, 'dialog');
        this._syncRenderedCardCtas(this.gridElement);

        if (this.autoOpenQuickBuy && this.hasAttribute('open')) {
          requestAnimationFrame(() => this._focusFirstPurchaseAction());
        }
      }

      _appendProducts(products) {
        if (!this.gridElement || !Array.isArray(products) || products.length === 0) {
          return;
        }

        const loadingElement = this.gridElement.querySelector('[data-related-categories-loading-more]');
        const productMarkup = this.buildProductMarkup(products, 'dialog');

        if (loadingElement) {
          loadingElement.insertAdjacentHTML('beforebegin', productMarkup);
        } else {
          this.gridElement.insertAdjacentHTML('beforeend', productMarkup);
        }

        this._syncRenderedCardCtas(this.gridElement);
      }

      _buildProductCard(product, index, scope = 'dialog', renderKey = '') {
        if (product?.__htmlMarkup) {
          // The cached Liquid card is used on both the inline surface and the dialog.
          // Re-normalize it per render so x-drawer IDs and their aria-controls targets
          // never overlap with a card rendered on another recommendation surface.
          return this._normalizePreloadedProductMarkup(
            product.__htmlMarkup,
            Number(product.id || 0),
            renderKey || scope,
            index
          );
        }

        const productUrl = product.url || `${Shopify.routes.root}products/${product.handle}`;
        const productImage = product.image || product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
        const imageUrl = product.image ? this._normalizeUrl(product.image) : this._withWidth(productImage, 720);
        const directVariant = product.directVariantId
          ? { id: Number(product.directVariantId) }
          : Array.isArray(product.variants) ? product.variants.find((variant) => variant.available) || product.variants[0] : null;
        const canDirectAdd = Boolean(product.available && directVariant && (product.directVariantId || (product.variants && product.variants.length === 1)));
        const quickBuyHandle = product.quickBuyHandle || (product.handle && directVariant ? `${product.handle}?variant=${directVariant.id}` : product.handle || '');
        const canQuickAdd = Boolean(product.available && quickBuyHandle);
        const quickBuyId = `related-categories-quick-buy-${scope}-${this.id}-${product.id}-${index}`;
        const priceValue = Number(product.price || 0);
        const compareAtValue = Number(product.compare_at_price || 0);
        const price = product.priceText || this._formatMoney(priceValue);
        const compareAtPrice = product.compareAtText || (Number.isFinite(compareAtValue) && compareAtValue > priceValue
          ? this._formatMoney(compareAtValue)
          : '');
        const variantId = Number(product.variantId || product.directVariantId || directVariant?.id || this._extractVariantIdFromHandle(quickBuyHandle) || 0);

        return `
          <article
            class="related-categories-dialog__product"
            data-related-categories-card="true"
            data-related-categories-product-id="${Number(product.id || 0)}"
            data-related-categories-handle="${this._escapeAttribute(product.handle || '')}"
            data-related-categories-variant-id="${variantId || ''}"
            data-related-categories-direct-variant-id="${canDirectAdd ? Number(directVariant?.id || 0) : ''}"
            data-related-categories-direct-add="${canDirectAdd ? 'true' : 'false'}"
            data-related-categories-available="${product.available === false ? 'false' : 'true'}"
            data-related-categories-quick-buy-handle="${this._escapeAttribute(quickBuyHandle)}"
          >
            <a href="${productUrl}" class="related-categories-dialog__product-link">
              ${imageUrl ? `<img src="${imageUrl}" alt="${this._escapeHtml(product.title)}" class="related-categories-dialog__product-image" loading="lazy" width="360" height="360">` : ''}
            </a>

            <div class="related-categories-dialog__product-body">
              <div class="related-categories-dialog__product-copy">
                <a href="${productUrl}" class="related-categories-dialog__product-title">${this._escapeHtml(product.title)}</a>
                <div class="related-categories-dialog__product-price">
                  ${compareAtPrice ? `<s>${compareAtPrice}</s>` : ''}
                  <span>${price}</span>
                </div>
              </div>

              <div class="related-categories-dialog__product-actions related-categories-dialog__card-cta">
                ${this._buildCardCtaMarkup({
                  variantId,
                  directVariantId: Number(directVariant?.id || 0),
                  quickBuyHandle,
                  quickBuyId,
                  available: product.available !== false,
                  isDirectAdd: canDirectAdd,
                  buttonClassName: 'button button--sm button--primary related-categories-dialog__product-button',
                  soldOutClassName: 'button button--sm button--secondary related-categories-dialog__product-button'
                })}
              </div>
              ${canQuickAdd ? `<quick-buy-drawer id="${quickBuyId}" header-bordered open-from="bottom" handle="${this._escapeAttribute(quickBuyHandle)}" role="region" aria-live="polite" class="quick-buy-drawer drawer"></quick-buy-drawer>` : ''}
            </div>
          </article>
        `;
      }

      _buildCardCtaMarkup(options = {}) {
        const variantId = Number(options.variantId || 0);
        const directVariantId = Number(options.directVariantId || variantId || 0);
        const quickBuyHandle = options.quickBuyHandle || '';
        const quickBuyId = options.quickBuyId || '';
        const isDirectAdd = Boolean(options.isDirectAdd && directVariantId);
        const isAvailable = options.available !== false;
        const lineItem = options.cartLine || (variantId ? this._getCartLineForVariant(variantId) : null);
        const quantity = Number(lineItem?.quantity || 0);
        const addLabel = String(this.strings.add_short || this.strings.add_to_cart || '').replace(/^\+\s*/, '');
        const continueLabel = this.strings.continue_short || this.strings.continue_to_cart || addLabel;

        if (quantity > 0 && lineItem?.key) {
          return `
            <quantity-selector class="quantity-selector related-categories-dialog__quantity-selector">
              <button type="button" class="quantity-selector__button" aria-label="${this._escapeAttribute(this.strings.decrease_quantity || '')}">
                <span class="related-categories-dialog__quantity-selector-icon related-categories-dialog__quantity-selector-icon--minus" aria-hidden="true">&minus;</span>
              </button>
              <input
                type="number"
                is="quantity-input"
                inputmode="numeric"
                class="quantity-selector__input"
                value="${quantity}"
                min="0"
                data-related-categories-line-key="${this._escapeAttribute(lineItem.key)}"
                autocomplete="off"
              >
              <button type="button" class="quantity-selector__button" aria-label="${this._escapeAttribute(this.strings.increase_quantity || '')}">
                <span class="related-categories-dialog__quantity-selector-icon related-categories-dialog__quantity-selector-icon--plus" aria-hidden="true">+</span>
              </button>
            </quantity-selector>
          `;
        }

        if (quantity > 0) {
          return `
            <button type="button" is="custom-button" class="${options.buttonClassName || 'button button--primary related-categories-dialog__card-cta-button'}" data-related-categories-open-cart="true">
              <span class="related-categories-dialog__card-cta-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><circle cx="9" cy="20" r="1"></circle><circle cx="19" cy="20" r="1"></circle><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"></path></svg></span>
              <span>${this._escapeHtml(continueLabel)}</span>
            </button>
          `;
        }

        if (isDirectAdd) {
          return `
            <form method="post" action="${Shopify.routes.root}cart/add" is="product-form" class="related-categories-dialog__card-cta-form">
              <input type="hidden" name="quantity" value="1">
              <input type="hidden" name="id" value="${directVariantId}">
              <button type="submit" is="custom-button" class="${options.buttonClassName || 'button button--primary related-categories-dialog__card-cta-button'}">
                <span class="related-categories-dialog__card-cta-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><circle cx="9" cy="20" r="1"></circle><circle cx="19" cy="20" r="1"></circle><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"></path></svg></span>
                <span>${this._escapeHtml(addLabel)}</span>
              </button>
            </form>
          `;
        }

        if (isAvailable && quickBuyHandle && quickBuyId) {
          return `
            <button type="button" is="custom-button" class="${options.buttonClassName || 'button button--primary related-categories-dialog__card-cta-button'}" aria-controls="${this._escapeAttribute(quickBuyId)}" aria-expanded="false">
              <span class="related-categories-dialog__card-cta-icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true"><circle cx="9" cy="20" r="1"></circle><circle cx="19" cy="20" r="1"></circle><path d="M3 4h2l2.4 10.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6L21 8H6"></path></svg></span>
              <span>${this._escapeHtml(addLabel)}</span>
            </button>
          `;
        }

        return `
          <button type="button" class="${options.soldOutClassName || 'button button--secondary related-categories-dialog__card-cta-button'}" disabled>
            <span>${this._escapeHtml(this.strings.sold_out)}</span>
          </button>
        `;
      }

      _syncRenderedCardCtas(rootElement) {
        if (!(rootElement instanceof Element)) {
          return;
        }

        rootElement.querySelectorAll('[data-related-categories-card="true"]').forEach((cardElement) => {
          this._syncSingleCardCta(cardElement);
        });
      }

      _syncSingleCardCta(cardElement) {
        const ctaContainer = cardElement.querySelector('.related-categories-dialog__card-cta');

        if (!(ctaContainer instanceof Element)) {
          return;
        }

        const variantId = Number(cardElement.getAttribute('data-related-categories-variant-id') || 0);
        const productId = Number(cardElement.getAttribute('data-related-categories-product-id') || 0);
        const quickBuyHandle = cardElement.getAttribute('data-related-categories-quick-buy-handle') || '';
        const quickBuyDrawer = cardElement.querySelector('quick-buy-drawer[id]');
        const cartLine = variantId ? this._getCartLineForVariant(variantId) : this._getCartLineForProduct(productId);
        const productButton = cardElement.classList.contains('product-card--related-categories')
          ? 'button button--primary button--sm related-categories-dialog__card-cta-button'
          : 'button button--sm button--primary related-categories-dialog__product-button';
        const soldOutButton = cardElement.classList.contains('product-card--related-categories')
          ? 'button button--secondary button--sm related-categories-dialog__card-cta-button'
          : 'button button--sm button--secondary related-categories-dialog__product-button';

        ctaContainer.innerHTML = this._buildCardCtaMarkup({
          variantId,
          directVariantId: Number(cardElement.getAttribute('data-related-categories-direct-variant-id') || 0),
          quickBuyHandle,
          quickBuyId: quickBuyDrawer?.id || '',
          available: cardElement.getAttribute('data-related-categories-available') !== 'false',
          isDirectAdd: cardElement.getAttribute('data-related-categories-direct-add') === 'true',
          cartLine,
          buttonClassName: productButton,
          soldOutClassName: soldOutButton
        });

        cardElement.toggleAttribute('data-related-categories-in-cart', Boolean(cartLine?.quantity));
      }

      _renderStatus(message) {
        if (!this.statusElement) {
          return;
        }

        if (message) {
          this.statusElement.hidden = false;
          this.statusElement.textContent = message;
        } else {
          this.statusElement.hidden = true;
          this.statusElement.textContent = '';
        }
      }

      _setFiltersHidden(isHidden) {
        const normalizedValue = Boolean(isHidden);

        if (this._filtersHidden === normalizedValue) {
          return;
        }

        this._filtersHidden = normalizedValue;

        if (this.contentElement) {
          this.contentElement.dataset.filtersHidden = normalizedValue ? 'true' : 'false';
        }
      }

      _setLoadingMore(isLoading) {
        if (!this.gridElement) {
          return;
        }

        const existingLoader = this.gridElement.querySelector('[data-related-categories-loading-more]');

        if (!isLoading) {
          existingLoader?.remove();
          return;
        }

        if (existingLoader) {
          return;
        }

        const loader = document.createElement('div');
        loader.className = 'related-categories-dialog__loading-more';
        loader.setAttribute('data-related-categories-loading-more', '');
        loader.setAttribute('role', 'status');
        loader.setAttribute('aria-live', 'polite');
        loader.textContent = this.strings.loading || '';
        this.gridElement.append(loader);
      }

      _clearGrid() {
        if (this.gridElement) {
          this.gridElement.innerHTML = '';
        }
      }

      _formatMoney(amount) {
        // product.price comes from the Shopify JSON API in cents/subunits.
        // Delegates to the shared, locale-aware helper (assets/money-format.js).
        return window.theme.formatMoneyCents(amount);
      }

      _withWidth(url, width) {
        const normalizedUrl = typeof url === 'string'
          ? url
          : url?.src || url?.url || url?.originalSrc || '';

        if (!normalizedUrl) {
          return '';
        }

        return normalizedUrl.includes('?') ? `${normalizedUrl}&width=${width}` : `${normalizedUrl}?width=${width}`;
      }

      _interpolate(template, values) {
        const title = values?.title || '';
        return String(template || '')
          .replace(/__TITLE__/g, title)
          .replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => values[key] ?? '');
      }

      _normalizeCollectionCardMarkup(cardElement, productId, page, index) {
        const normalizedCard = cardElement.cloneNode(true);
        const uniqueBaseId = `related-categories-native-${this.id}-${productId}-${page}-${index}`;
        const quickBuyButton = normalizedCard.querySelector('[aria-controls]');
        const quickBuyDrawer = normalizedCard.querySelector('quick-buy-drawer[id]');
        const directVariantId = Number(normalizedCard.querySelector('.product-card__quick-buy form input[name="id"]')?.value || 0);
        const quickBuyHandle = quickBuyDrawer?.getAttribute('handle') || '';
        const variantId = directVariantId || this._extractVariantIdFromHandle(quickBuyHandle);
        const hasPurchaseAction = Boolean(directVariantId || quickBuyHandle || normalizedCard.querySelector('.product-card__mobile-quick-buy-button'));

        normalizedCard.removeAttribute('reveal-js');
        normalizedCard.classList.add('product-card--related-categories');
        normalizedCard.setAttribute('data-related-categories-card', 'true');
        normalizedCard.setAttribute('data-related-categories-product-id', String(productId));
        normalizedCard.setAttribute('data-related-categories-variant-id', variantId ? String(variantId) : '');
        normalizedCard.setAttribute('data-related-categories-direct-variant-id', directVariantId ? String(directVariantId) : '');
        normalizedCard.setAttribute('data-related-categories-direct-add', directVariantId ? 'true' : 'false');
        normalizedCard.setAttribute('data-related-categories-available', hasPurchaseAction ? 'true' : 'false');
        normalizedCard.setAttribute('data-related-categories-quick-buy-handle', quickBuyHandle);

        if (quickBuyButton && quickBuyDrawer) {
          const quickBuyId = `${uniqueBaseId}-quick-buy`;
          quickBuyButton.setAttribute('aria-controls', quickBuyId);
          quickBuyDrawer.id = quickBuyId;
        }

        // Product-card markup is reused for the inline recommendations and this dialog.
        // Give every cloned membership drawer a dialog-specific ID so its trigger cannot
        // toggle matching drawers elsewhere on the page.
        normalizedCard.querySelectorAll('x-drawer.member-price-info-trigger__drawer[id]').forEach((drawer, drawerIndex) => {
          const originalDrawerId = drawer.id;
          const memberDrawerId = `${uniqueBaseId}-member-price-info-${drawerIndex + 1}`;

          normalizedCard.querySelectorAll('[aria-controls]').forEach((trigger) => {
            if (trigger.getAttribute('aria-controls') === originalDrawerId) {
              trigger.setAttribute('aria-controls', memberDrawerId);
            }
          });

          drawer.id = memberDrawerId;
        });

        normalizedCard.querySelectorAll('.wk-button, [aria-label="Add to Wishlist"], [href*="/apps/wishlist"]').forEach((element) => {
          element.remove();
        });

        normalizedCard.querySelectorAll('form[id]').forEach((formElement, formIndex) => {
          formElement.id = `${uniqueBaseId}-form-${formIndex + 1}`;
        });

        // Preloaded cards can be normalized more than once (for inline and dialog
        // renders). Remove the CTA injected by an earlier pass before adding this one.
        normalizedCard.querySelectorAll('.related-categories-dialog__card-cta').forEach((element) => {
          element.remove();
        });

        const ctaContainer = document.createElement('div');
        ctaContainer.className = 'related-categories-dialog__card-cta';
        ctaContainer.innerHTML = this._buildCardCtaMarkup({
          variantId,
          directVariantId,
          quickBuyHandle,
          quickBuyId: quickBuyDrawer?.id || '',
          available: hasPurchaseAction,
          isDirectAdd: Boolean(directVariantId),
          buttonClassName: 'button button--primary button--sm related-categories-dialog__card-cta-button',
          soldOutClassName: 'button button--secondary button--sm related-categories-dialog__card-cta-button'
        });

        const infoStackElement = normalizedCard.querySelector('.product-card__info > .v-stack');
        const infoElement = normalizedCard.querySelector('.product-card__info');
        const trailingCardRows = infoElement
          ? Array.from(infoElement.children).filter((element) => (
            element.classList.contains('product-card__status-stack')
            || element.classList.contains('product-card__inventory')
            || element.classList.contains('product-card__shipping-note')
            || element.classList.contains('product-card__delivery-message')
          ))
          : [];

        if (infoStackElement) {
          const priceRowElement = infoStackElement.querySelector('.product-card__price-with-badge');
          const stateWrapper = document.createElement('div');
          stateWrapper.className = 'related-categories-dialog__card-state';

          if (priceRowElement) {
            const attributeWrapper = document.createElement('div');
            attributeWrapper.className = 'related-categories-dialog__card-attributes';
            let attributeCount = 0;

            Array.from(infoStackElement.children).forEach((element) => {
              if (element === priceRowElement) {
                return;
              }

              if (element.classList.contains('product-card__aside')) {
                attributeWrapper.append(element);
                attributeCount += 1;
              }
            });

            attributeWrapper.dataset.relatedCategoriesAsideCount = String(attributeCount);

            if (attributeCount > 0) {
              priceRowElement.before(attributeWrapper);
            }
          }

          trailingCardRows.forEach((element) => {
            stateWrapper.append(element);
          });

          if (stateWrapper.childElementCount > 0) {
            stateWrapper.dataset.relatedCategoriesStateCount = String(stateWrapper.childElementCount);
            infoStackElement.append(stateWrapper);
          }

          infoStackElement.append(ctaContainer);
        } else if (infoElement) {
          infoElement.append(ctaContainer);
        } else {
          normalizedCard.append(ctaContainer);
        }

        return normalizedCard.outerHTML;
      }

      _normalizePreloadedProductMarkup(markup, productId, sourceKey, index) {
        if (!markup) {
          return '';
        }

        const wrapper = document.createElement('div');
        wrapper.innerHTML = String(markup).trim();
        const cardElement = wrapper.firstElementChild;

        if (!(cardElement instanceof Element)) {
          return '';
        }

        return this._normalizeCollectionCardMarkup(cardElement, productId, sourceKey, index);
      }

      _extractCollectionCardData(cardElement) {
        const productId = Number(cardElement.querySelector('input[name="product-id"]')?.value || 0);
        const productUrl = cardElement.querySelector('.product-card__title a, .product-card__figure > a')?.getAttribute('href') || '';
        const handleFromAttribute = cardElement.getAttribute('handle') || '';
        const handleFromUrl = this._extractHandleFromUrl(productUrl);
        const directVariantId = Number(cardElement.querySelector('.product-card__quick-buy form input[name="id"]')?.value || 0);
        const quickBuyHandle = cardElement.querySelector('quick-buy-drawer[handle]')?.getAttribute('handle') || '';
        const primaryImage = cardElement.querySelector('.product-card__image--primary');
        const imageSource = primaryImage?.getAttribute('src') || primaryImage?.getAttribute('data-src') || '';
        const priceEntries = Array.from(cardElement.querySelectorAll('.product-card__price-with-badge .card-price-item, .product-card__price .card-price-item'))
          .map((node) => this._collapseWhitespace(node.textContent))
          .filter(Boolean);
        const fallbackPrice = this._collapseWhitespace(
          cardElement.querySelector('.product-card__price-with-badge .red-price, .product-card__price .red-price, .product-card__price')?.textContent || ''
        );
        const priceText = priceEntries[0] || fallbackPrice;
        const compareAtText = priceEntries[1] && priceEntries[1] !== priceText ? priceEntries[1] : '';
        const hasPurchaseAction = Boolean(directVariantId || quickBuyHandle || cardElement.querySelector('.product-card__mobile-quick-buy-button'));
        const variantId = directVariantId || this._extractVariantIdFromHandle(quickBuyHandle);

        return {
          id: productId,
          handle: handleFromAttribute || handleFromUrl,
          title: this._collapseWhitespace(cardElement.querySelector('.product-card__title')?.textContent || ''),
          url: this._normalizeUrl(productUrl),
          image: this._normalizeUrl(imageSource),
          available: hasPurchaseAction,
          variantId: variantId || null,
          directVariantId: directVariantId || null,
          quickBuyHandle: quickBuyHandle || (handleFromAttribute || handleFromUrl),
          priceText,
          compareAtText,
          priceValue: this._parseMoneyString(priceText),
          compareAtValue: this._parseMoneyString(compareAtText)
        };
      }

      _extractHandleFromUrl(url) {
        const normalizedUrl = String(url || '').split('?')[0];
        const matchedHandle = normalizedUrl.match(/\/products\/([^/]+)/);
        return matchedHandle?.[1] || '';
      }

      _extractVariantIdFromHandle(handle) {
        if (!handle) {
          return 0;
        }

        try {
          const normalizedHandle = handle.startsWith('http')
            ? new URL(handle)
            : new URL(handle.startsWith('/') ? handle : `${Shopify.routes.root}products/${handle}`, window.location.origin);
          return Number(normalizedHandle.searchParams.get('variant') || 0);
        } catch (error) {
          const matchedVariant = String(handle).match(/[?&]variant=(\d+)/);
          return Number(matchedVariant?.[1] || 0);
        }
      }

      _normalizeUrl(url) {
        if (!url) {
          return '';
        }

        if (url.startsWith('//')) {
          return `${window.location.protocol}${url}`;
        }

        if (url.startsWith('/')) {
          return `${window.location.origin}${url}`;
        }

        return url;
      }

      _collapseWhitespace(value) {
        return String(value || '').replace(/\s+/g, ' ').trim();
      }

      _documentHasNextPage(documentFragment, currentPage) {
        const nextPage = currentPage + 1;

        return Array.from(documentFragment.querySelectorAll('a[href], link[href]')).some((element) => {
          const href = element.getAttribute('href');

          if (!href) {
            return false;
          }

          try {
            return new URL(href, window.location.origin).searchParams.get('page') === String(nextPage);
          } catch (error) {
            return false;
          }
        });
      }

      _getCollectionUrlCandidates(category, page = 1) {
        const normalizedCategoryUrl = this._normalizeUrl(category?.url || '');
        const localeCollectionUrl = `${window.location.origin}${Shopify.routes.root}collections/${category.handle}`;
        const fallbackCollectionUrl = `${window.location.origin}/collections/${category.handle}`;

        return Array.from(new Set([normalizedCategoryUrl, localeCollectionUrl, fallbackCollectionUrl].filter(Boolean)))
          .map((collectionUrl) => this._withPageParam(collectionUrl, page));
      }

      _getCollectionSectionUrlCandidates(category, page = 1) {
        return this._getCollectionUrlCandidates(category, page).flatMap((collectionUrl) => {
          const sectionUrls = [];

          ['template--28997870682376__main', 'main', 'template--main'].forEach((sectionId) => {
            const parsedUrl = new URL(collectionUrl, window.location.origin);
            parsedUrl.searchParams.set('section_id', sectionId);
            sectionUrls.push(parsedUrl.toString());
          });

          return sectionUrls;
        });
      }

      _getCollectionJsonUrlCandidates(category, pageSize, page) {
        return this._getCollectionUrlCandidates(category, page).map((collectionUrl) => {
          const parsedUrl = new URL(collectionUrl, window.location.origin);
          const normalizedPath = parsedUrl.pathname.replace(/\/$/, '');
          parsedUrl.pathname = `${normalizedPath}/products.json`;
          parsedUrl.searchParams.set('limit', String(pageSize));
          parsedUrl.searchParams.set('page', String(page));
          return parsedUrl.toString();
        });
      }

      _withPageParam(url, page) {
        const parsedUrl = new URL(url, window.location.origin);

        if (page > 1) {
          parsedUrl.searchParams.set('page', String(page));
        } else {
          parsedUrl.searchParams.delete('page');
        }

        return parsedUrl.toString();
      }

      _escapeAttribute(value) {
        return String(value ?? '')
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;');
      }

      _escapeHtml(value) {
        const fragment = document.createElement('span');
        fragment.textContent = value ?? '';
        return fragment.innerHTML;
      }

      _captureAtcButtonPalette() {
        const buttonSelectors = [
          '.product-info__buy-buttons .button--xl',
          '.purchase-card__buy-buttons .button--xl',
          'buy-buttons .button--xl',
          '.product-info__buy-buttons .button',
          '.purchase-card__buy-buttons .button',
          'buy-buttons .button'
        ];

        const candidates = buttonSelectors.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
        const matchedButton = candidates.find((button) => {
          const computedStyle = window.getComputedStyle(button);

          return computedStyle.display !== 'none'
            && computedStyle.visibility !== 'hidden'
            && computedStyle.backgroundColor
            && !computedStyle.backgroundColor.includes('0, 0, 0, 0');
        });

        if (!matchedButton) {
          return;
        }

        const computedStyle = window.getComputedStyle(matchedButton);
        const backgroundChannels = this._extractRgbChannels(computedStyle.backgroundColor);
        const textChannels = this._extractRgbChannels(computedStyle.color);

        if (!backgroundChannels) {
          return;
        }

        let inlineStyle = `--related-categories-continue-background: ${backgroundChannels}; --related-categories-continue-border: ${backgroundChannels};`;

        if (textChannels) {
          inlineStyle += ` --related-categories-continue-text: ${textChannels};`;
        }

        this._continueButtonInlineStyle = inlineStyle;
      }

      _extractRgbChannels(colorValue) {
        const matchedChannels = String(colorValue || '').match(/rgba?\(([^)]+)\)/);

        if (!matchedChannels?.[1]) {
          return '';
        }

        const channelValues = matchedChannels[1]
          .split(',')
          .slice(0, 3)
          .map((channel) => Math.round(Number(channel.trim())))
          .filter((channel) => Number.isFinite(channel));

        return channelValues.length === 3 ? channelValues.join(' ') : '';
      }

      preOpenCartDrawer(delay = 450) {
        window.clearTimeout(this._cartDrawerOpenTimeout);
        this._cartDrawerOpenTimeout = window.setTimeout(() => {
          const cartDrawer = this._openCartDrawer();

          if (cartDrawer?.tagName?.toLowerCase() === 'cart-drawer') {
            this._pinCartDrawerForPopup(cartDrawer);
          }
        }, delay);
      }

      _openCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.show();
          return cartDrawer;
        }

        const cartNotificationDrawer = document.querySelector('cart-notification-drawer');

        if (cartNotificationDrawer && typeof cartNotificationDrawer.show === 'function') {
          cartNotificationDrawer.show();
          return cartNotificationDrawer;
        }

        const cartTrigger = document.querySelector('[aria-controls="cart-drawer"], a[href$="/cart"], a[href*="/cart?"]');
        if (cartTrigger instanceof HTMLElement) {
          cartTrigger.click();
        }

        return document.querySelector('cart-drawer');
      }

      _pinCartDrawerForPopup(cartDrawer) {
        if (!(cartDrawer instanceof HTMLElement) || cartDrawer.__relatedCategoriesOutsideClickHandlers) {
          this._pinnedCartDrawer = cartDrawer;
          return;
        }

        const isPopupTarget = (eventTarget) => eventTarget instanceof Node && this.contains(eventTarget);
        const originalHandlers = {
          allowOutsideClick: typeof cartDrawer._allowOutsideClick === 'function' ? cartDrawer._allowOutsideClick.bind(cartDrawer) : null,
          allowOutsideClickMouse: typeof cartDrawer._allowOutsideClickMouse === 'function' ? cartDrawer._allowOutsideClickMouse.bind(cartDrawer) : null,
          allowOutsideClickTouch: typeof cartDrawer._allowOutsideClickTouch === 'function' ? cartDrawer._allowOutsideClickTouch.bind(cartDrawer) : null
        };

        if (originalHandlers.allowOutsideClick) {
          cartDrawer._allowOutsideClick = (event) => {
            if (isPopupTarget(event?.target)) {
              return true;
            }

            return originalHandlers.allowOutsideClick(event);
          };
        }

        if (originalHandlers.allowOutsideClickMouse) {
          cartDrawer._allowOutsideClickMouse = (event) => {
            if (isPopupTarget(event?.target)) {
              return true;
            }

            return originalHandlers.allowOutsideClickMouse(event);
          };
        }

        if (originalHandlers.allowOutsideClickTouch) {
          cartDrawer._allowOutsideClickTouch = (event) => {
            if (isPopupTarget(event?.target)) {
              return true;
            }

            return originalHandlers.allowOutsideClickTouch(event);
          };
        }

        cartDrawer.__relatedCategoriesOutsideClickHandlers = originalHandlers;
        this._pinnedCartDrawer = cartDrawer;
      }

      _releasePinnedCartDrawer() {
        const cartDrawer = this._pinnedCartDrawer;
        const originalHandlers = cartDrawer?.__relatedCategoriesOutsideClickHandlers;

        if (!(cartDrawer instanceof HTMLElement) || !originalHandlers) {
          this._pinnedCartDrawer = null;
          return;
        }

        if (originalHandlers.allowOutsideClick) {
          cartDrawer._allowOutsideClick = originalHandlers.allowOutsideClick;
        }

        if (originalHandlers.allowOutsideClickMouse) {
          cartDrawer._allowOutsideClickMouse = originalHandlers.allowOutsideClickMouse;
        }

        if (originalHandlers.allowOutsideClickTouch) {
          cartDrawer._allowOutsideClickTouch = originalHandlers.allowOutsideClickTouch;
        }

        delete cartDrawer.__relatedCategoriesOutsideClickHandlers;
        this._pinnedCartDrawer = null;
      }

      _focusFirstPurchaseAction() {
        if (!this.autoOpenQuickBuy || !this.gridElement) {
          return;
        }

        const firstPurchaseAction = this.gridElement.querySelector(
          '.related-categories-dialog__product-button, .product-card__mobile-quick-buy-button, button[type="submit"]'
        );

        firstPurchaseAction?.focus({ preventScroll: true });

        this.autoOpenQuickBuy = false;
      }

      _showTransition(animate) {
        const duration = animate ? 220 : 0;
        const backdropAnimation = this.backdrop?.animate(
          [{ opacity: 0 }, { opacity: 1 }],
          { duration, easing: 'ease', fill: 'forwards' }
        );
        const panelAnimation = this.querySelector('.related-categories-dialog__panel')?.animate(
          window.matchMedia('(min-width: 1000px)').matches
            ? [{ opacity: 0, transform: 'translateY(1rem) scale(0.98)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }]
            : [{ opacity: 0, transform: 'translateY(2rem)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: animate ? 280 : 0, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
        );

        return Promise.all([backdropAnimation?.finished, panelAnimation?.finished].filter(Boolean));
      }

      _hideTransition() {
        const backdropAnimation = this.backdrop?.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 180, easing: 'ease', fill: 'forwards' }
        );
        const panelAnimation = this.querySelector('.related-categories-dialog__panel')?.animate(
          window.matchMedia('(min-width: 1000px)').matches
            ? [{ opacity: 1, transform: 'translateY(0) scale(1)' }, { opacity: 0, transform: 'translateY(1rem) scale(0.98)' }]
            : [{ opacity: 1, transform: 'translateY(0)' }, { opacity: 0, transform: 'translateY(2rem)' }],
          { duration: 180, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
        );

        return Promise.all([backdropAnimation?.finished, panelAnimation?.finished].filter(Boolean));
      }
    }

    customElements.define('related-categories-dialog', RelatedCategoriesDialog);
  }

  if (!customElements.get('related-categories-popup-section')) {
    const RELATED_CATEGORIES_GLOBAL_KEY = 'DancoverRelatedCategories';
    const RELATED_CATEGORIES_MAIN_ATC_EVENT = 'dancover:related-categories:main-atc-popup-change';

    const normalizeMainAtcPopupEnabled = (value) => value === true || value === 'true' || value === 1 || value === '1';

    const getRelatedCategoriesRuntime = () => {
      const runtime = window[RELATED_CATEGORIES_GLOBAL_KEY] && typeof window[RELATED_CATEGORIES_GLOBAL_KEY] === 'object'
        ? window[RELATED_CATEGORIES_GLOBAL_KEY]
        : {};

      if (!runtime.state || typeof runtime.state !== 'object') {
        runtime.state = {};
      }

      if (typeof runtime.state.mainAtcPopupEnabled !== 'boolean') {
        runtime.state.mainAtcPopupEnabled = false;
      }

      runtime.setMainAtcPopupEnabled = (enabled) => {
        const normalizedEnabled = normalizeMainAtcPopupEnabled(enabled);
        runtime.state.mainAtcPopupEnabled = normalizedEnabled;
        window.dispatchEvent(
          new CustomEvent(RELATED_CATEGORIES_MAIN_ATC_EVENT, {
            detail: { enabled: normalizedEnabled }
          })
        );

        return normalizedEnabled;
      };

      window[RELATED_CATEGORIES_GLOBAL_KEY] = runtime;

      return runtime;
    };

    class RelatedCategoriesPopupSection extends HTMLElement {
      constructor() {
        super();
        this._onClick = this._onClick.bind(this);
        this._onVariantAdded = this._onVariantAdded.bind(this);
        this._onProductFormSubmitCapture = this._onProductFormSubmitCapture.bind(this);
        this._onDialogChange = this._onDialogChange.bind(this);
        this._onInlineCartChange = this._onInlineCartChange.bind(this);
        this._onInlineCartRefresh = this._onInlineCartRefresh.bind(this);
        this._onResize = this._onResize.bind(this);
        this._onMainAtcPopupToggle = this._onMainAtcPopupToggle.bind(this);
        this.inlineProductCount = 4;
      }

      connectedCallback() {
        this.sectionRoot = this.closest('[data-related-categories-section-root]');
        this.sectionTitle = this.sectionRoot?.dataset.relatedCategoriesSectionTitle || '';
        this.dialog = this.querySelector(`#${this.dataset.dialogId}`);
        this.triggers = Array.from(this.querySelectorAll('[data-related-category-trigger]'));
        this.inlineStatusElement = this.querySelector('[data-related-categories-inline-status]');
        this.inlineGridElement = this.querySelector('[data-related-categories-inline-grid]');
        this.inlineViewAllElement = this.querySelector('[data-related-categories-inline-view-all]');
        this.productId = Number(this.dataset.productId || 0);
        this.limit = Number(this.dataset.productsLimit || 8);
        this._runtime = getRelatedCategoriesRuntime();
        const preloadedProductsElement = this.querySelector('[data-related-categories-preloaded]');
        const preloadedProductsByHandle = preloadedProductsElement ? JSON.parse(preloadedProductsElement.textContent) : {};
        this.categories = this.triggers.map((button) => ({
          sourceType: button.dataset.categorySource || 'collection',
          handle: button.dataset.categoryHandle || '',
          image: button.dataset.categoryImage || '',
          title: button.dataset.categoryTitle || '',
          url: button.dataset.categoryUrl || '',
          totalCount: Number(button.dataset.categoryTotalCount || 0),
          index: Number(button.dataset.categoryIndex || 0),
          preloadedProducts: Array.isArray(preloadedProductsByHandle[button.dataset.categoryHandle || ''])
            ? preloadedProductsByHandle[button.dataset.categoryHandle || '']
            : []
        }));

        const stringsElement = this.querySelector('[data-related-categories-i18n]');
        const strings = stringsElement ? JSON.parse(stringsElement.textContent) : {};
        this._sectionPopupEnabled = this._shouldEnableSectionPopup();
        this._mainAtcPopupEnabled = this._resolveMainAtcPopupEnabled();

        document.addEventListener('submit', this._onProductFormSubmitCapture, true);
        document.addEventListener('variant:add', this._onVariantAdded, true);
        window.addEventListener(RELATED_CATEGORIES_MAIN_ATC_EVENT, this._onMainAtcPopupToggle);

        this._syncRuntimeState();

        if (!this.dialog || typeof this.dialog.configure !== 'function') {
          return;
        }

        this.dialog.configure({
          categories: this.categories,
          productId: this.productId,
          limit: this.limit,
          strings
        });

        this.addEventListener('click', this._onClick);
        this.dialog.addEventListener('related-categories:change', this._onDialogChange);
        document.documentElement.addEventListener('cart:change', this._onInlineCartChange);
        document.addEventListener('cart:refresh', this._onInlineCartRefresh);
        window.addEventListener('resize', this._onResize, { passive: true });
        this.inlineProductCount = this._getInlineProductCount();

        const initialIndex = this.dialog.activeIndex > -1 ? this.dialog.activeIndex : 0;
        this._syncActiveTrigger(initialIndex);
        this._loadInlineCategory(initialIndex);
        // Load other categories only after explicit customer interaction.
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.dialog?.removeEventListener('related-categories:change', this._onDialogChange);
        document.removeEventListener('submit', this._onProductFormSubmitCapture, true);
        document.removeEventListener('variant:add', this._onVariantAdded, true);
        document.documentElement.removeEventListener('cart:change', this._onInlineCartChange);
        document.removeEventListener('cart:refresh', this._onInlineCartRefresh);
        window.removeEventListener('resize', this._onResize);
        window.removeEventListener(RELATED_CATEGORIES_MAIN_ATC_EVENT, this._onMainAtcPopupToggle);
      }

      setMainAtcPopupEnabled(enabled) {
        this._mainAtcPopupEnabled = normalizeMainAtcPopupEnabled(enabled);

        if (this._runtime?.state) {
          this._runtime.state.mainAtcPopupEnabled = this._mainAtcPopupEnabled;
        }

        this._syncRuntimeState();
      }

      _resolveMainAtcPopupEnabled() {
        if (typeof this._runtime?.state?.mainAtcPopupEnabled === 'boolean') {
          return this._runtime.state.mainAtcPopupEnabled;
        }

        return normalizeMainAtcPopupEnabled(this.dataset.mainAtcPopupEnabled);
      }

      _shouldEnableSectionPopup() {
        return Boolean(this.dialog) && this.categories.length > 0;
      }

      _syncRuntimeState() {
        const mainAtcPopupEnabled = this._mainAtcPopupEnabled ? 'true' : 'false';

        this.dataset.mainAtcPopupEnabled = mainAtcPopupEnabled;

        if (!(this.sectionRoot instanceof HTMLElement)) {
          return;
        }

        this.sectionRoot.dataset.relatedCategoriesPopupEnabled = this._sectionPopupEnabled ? 'true' : 'false';
        this.sectionRoot.dataset.relatedCategoriesMainAtcPopupEnabled = mainAtcPopupEnabled;
        this.sectionRoot.hidden = false;
      }

      _onMainAtcPopupToggle(event) {
        this.setMainAtcPopupEnabled(event?.detail?.enabled);
      }

      _openPopupForCategory(index, triggerSurface, options = {}) {
        if (!this._sectionPopupEnabled || !this.dialog) {
          return;
        }

        const normalizedIndex = Number.isInteger(index) && index >= 0 ? index : 0;
        this.dialog.showCategory(normalizedIndex, {
          autoOpenQuickBuy: options.autoOpenQuickBuy !== false,
          continueToCart: Boolean(options.continueToCart)
        });

        if (options.continueToCart) {
          this.dialog.preOpenCartDrawer(550);
        }

        this._syncActiveTrigger(normalizedIndex);
      }

      _selectInlineCategory(index) {
        if (!this.dialog) {
          return;
        }

        const normalizedIndex = Number.isInteger(index) && index >= 0 ? index : 0;
        this.dialog.setActiveCategory(normalizedIndex);
        this._syncActiveTrigger(normalizedIndex);
      }

      _onClick(event) {
        const target = event.target;

        if (!(target instanceof Element)) {
          return;
        }

        const inlineViewMoreButton = target.closest('[data-related-categories-inline-view-all]');

        if (inlineViewMoreButton && this.contains(inlineViewMoreButton)) {
          event.preventDefault();
          event.stopPropagation();

          const activeIndex = Number.isInteger(this.inlineActiveIndex) ? this.inlineActiveIndex : (this.dialog.activeIndex > -1 ? this.dialog.activeIndex : 0);
          if (!this._sectionPopupEnabled) {
            return;
          }

          this._openPopupForCategory(activeIndex, 'section_view_more');
          return;
        }

        const openCartButton = target.closest('[data-related-categories-open-cart]');

        if (openCartButton && this.contains(openCartButton)) {
          event.preventDefault();
          event.stopPropagation();
          this.dialog?._openCartDrawer?.();
          return;
        }

        const trigger = target.closest('[data-related-category-trigger]');

        if (!trigger || !this.contains(trigger)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const index = Number(trigger.dataset.categoryIndex || 0);

        if (!this._sectionPopupEnabled) {
          this._selectInlineCategory(index);
          return;
        }

        this._openPopupForCategory(index, 'section_tab');
      }

      _onProductFormSubmitCapture(event) {
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) {
          return;
        }

        if (!this._isCurrentProductForm(form)) {
          return;
        }

        this._pendingMainProductAddUntil = Date.now() + 8000;
        this._pendingMainProductForm = form;
      }

      _onVariantAdded(event) {
        const target = event.target;
        const isPopupAdd = target instanceof Element && Boolean(target.closest('related-categories-dialog'));
        const isInlineAdd = target instanceof Element && this.inlineGridElement instanceof Element && this.inlineGridElement.contains(target);

        if (isPopupAdd) {
          if (event.detail) {
            event.detail.blockCartDrawerOpening = true;
          }

          return;
        }

        if (isInlineAdd) {
          return;
        }

        const items = Array.isArray(event.detail?.items) ? event.detail.items : [];
        const addedCurrentProduct = this._isPendingMainProductAdd(event) || this._isCurrentProductAddEvent(event, items);

        if (!addedCurrentProduct) {
          return;
        }

        this._pendingMainProductAddUntil = 0;
        this._pendingMainProductForm = null;
        const activeIndex = this.dialog?.activeIndex > -1 ? this.dialog.activeIndex : 0;

        if (!this._mainAtcPopupEnabled || this.categories.length === 0) {
          return;
        }

        if (event.detail) {
          event.detail.blockCartDrawerOpening = true;
        }

        this._openPopupForCategory(activeIndex, 'pdp_main', { continueToCart: true });
      }

      _isPendingMainProductAdd(event) {
        if (Date.now() >= Number(this._pendingMainProductAddUntil || 0)) {
          this._pendingMainProductForm = null;
          return false;
        }

        const pendingForm = this._pendingMainProductForm;
        const target = event?.target;

        return pendingForm instanceof HTMLFormElement && target instanceof Node && (target === pendingForm || pendingForm.contains(target));
      }

      _isCurrentProductForm(form) {
        if (!(form instanceof HTMLFormElement) || this.contains(form) || !this.productId) {
          return false;
        }

        const isCartAddForm = form.matches('form[is="product-form"], form[action*="/cart/add"]');

        if (!isCartAddForm) {
          return false;
        }

        const formProductId = Number(form.querySelector('input[name="product-id"]')?.value || 0);

        if (formProductId === this.productId) {
          return true;
        }

        const formId = form.getAttribute('id') || '';
        const productFormId = formId.match(/product-form-(\d+)/);

        if (Number(productFormId?.[1] || 0) === this.productId) {
          return true;
        }

        const productInput = Number(form.querySelector('input[name="product_id"], input[name="product-id"]')?.value || 0);

        if (productInput === this.productId) {
          return true;
        }

        return Boolean(form.closest('main-product, .shopify-section--main-product, [id*="__main-product"], [id*="main-product"]'));
      }

      _isCurrentProductAddEvent(event, items = []) {
        if (items.some((item) => Number(item?.product_id || 0) === this.productId)) {
          return true;
        }

        const target = event?.target;

        if (!(target instanceof Element) || !this.productId) {
          return false;
        }

        return this._isCurrentProductForm(target.closest('form[is="product-form"], form[action*="/cart/add"]'));
      }

      _getInlineProductCount() {
        return window.matchMedia('(min-width: 1000px)').matches ? 8 : 4;
      }

      _onResize() {
        const nextCount = this._getInlineProductCount();

        if (nextCount === this.inlineProductCount) {
          return;
        }

        this.inlineProductCount = nextCount;

        if (!Number.isInteger(this.inlineActiveIndex)) {
          return;
        }

        const cachedProducts = this.dialog?.getCachedProducts(this.inlineActiveIndex) || [];

        if (cachedProducts.length > 0) {
          this._renderInlineProducts(cachedProducts);
        }
      }

      _onInlineCartChange() {
        if (this.inlineGridElement instanceof Element) {
          this.dialog?._syncRenderedCardCtas?.(this.inlineGridElement);
        }
      }

      async _onInlineCartRefresh() {
        if (!this.dialog) {
          return;
        }

        await this.dialog._hydrateCartState?.();

        if (this.inlineGridElement instanceof Element) {
          this.dialog._syncRenderedCardCtas?.(this.inlineGridElement);
        }
      }

      _onDialogChange(event) {
        const activeIndex = Number(event.detail?.index || 0);
        this._syncActiveTrigger(activeIndex);
        this._loadInlineCategory(activeIndex);
      }

      async _loadInlineCategory(index) {
        const category = this.categories[index];

        if (!category || !this.dialog) {
          return;
        }

        this.inlineActiveIndex = index;
        if (this.inlineViewAllElement) {
          this.inlineViewAllElement.hidden = true;
        }

        const cachedProducts = this.dialog.getCachedProducts(index);

        if (cachedProducts.length > 0) {
          if (this.inlineActiveIndex === index) {
            this._renderInlineProducts(cachedProducts);
          }

          return;
        }

        this._renderInlineStatus(this.dialog.strings.loading);
        this._clearInlineGrid();

        try {
          const products = await this.dialog.ensureCategoryProducts(index);

          if (this.inlineActiveIndex === index) {
            this._renderInlineProducts(products);
          }
        } catch (error) {
          if (this.inlineActiveIndex === index) {
            console.error(`[related-categories-popup] inline load failed | category=${category.handle} | collection=${category.url} | page=${window.location.href} | error=${error?.message || error}`);
            this._renderInlineStatus(this.dialog.strings.error);
            this._updateInlineViewAllVisibility(this.inlineActiveIndex, []);
          }
        }
      }

      _renderInlineProducts(products) {
        if (!Array.isArray(products) || products.length === 0) {
          this._renderInlineStatus(this.dialog.strings.empty);
          this._clearInlineGrid();
          this._updateInlineViewAllVisibility(this.inlineActiveIndex, []);
          return;
        }

        this._renderInlineStatus('');
        const visibleProducts = products.slice(0, this.inlineProductCount);
        this.inlineGridElement.innerHTML = this.dialog.buildProductMarkup(visibleProducts, 'inline');
        this.dialog._syncRenderedCardCtas(this.inlineGridElement);
        this._updateInlineViewAllVisibility(this.inlineActiveIndex, visibleProducts);
      }

      _renderInlineStatus(message) {
        if (!this.inlineStatusElement) {
          return;
        }

        if (message) {
          this.inlineStatusElement.hidden = false;
          this.inlineStatusElement.textContent = message;
        } else {
          this.inlineStatusElement.hidden = true;
          this.inlineStatusElement.textContent = '';
        }
      }

      _clearInlineGrid() {
        if (this.inlineGridElement) {
          this.inlineGridElement.innerHTML = '';
        }
      }

      _updateInlineViewAllVisibility(index, visibleProducts) {
        if (!this.inlineViewAllElement || !this.dialog || !Number.isInteger(index)) {
          return;
        }

        const categorySummary = this.dialog.getCategorySummary(index);
        const displayedCount = Array.isArray(visibleProducts) ? visibleProducts.length : 0;
        const cachedCount = Number(categorySummary?.cachedCount || 0);
        const totalCount = Number(categorySummary?.totalCount || 0);
        const hasAdditionalProducts = cachedCount > displayedCount || totalCount > displayedCount || Boolean(categorySummary?.hasMore);
        const hasOtherTabsToExplore = this.categories.some((category, categoryIndex) => {
          if (categoryIndex === index) {
            return false;
          }

          const otherSummary = this.dialog.getCategorySummary(categoryIndex);
          return Number(category?.totalCount || otherSummary?.totalCount || otherSummary?.cachedCount || 0) > 0 || Boolean(otherSummary?.hasMore);
        });

        this.inlineViewAllElement.hidden = !this._sectionPopupEnabled || (!hasAdditionalProducts && !hasOtherTabsToExplore);
      }

      _syncActiveTrigger(activeIndex) {
        this.triggers?.forEach((button) => {
          const isActive = Number(button.dataset.categoryIndex || 0) === activeIndex;
          button.dataset.active = isActive ? 'true' : 'false';
          button.setAttribute('aria-expanded', isActive && this.dialog?.hasAttribute('open') ? 'true' : 'false');
        });
      }
    }

    customElements.define('related-categories-popup-section', RelatedCategoriesPopupSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-fast-contact-usp-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fast-contact-usp-bar')) {
    class FastContactUspBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
  
        this.messages = Array.from(this.querySelectorAll('[data-message]'));
        this.countdowns = Array.from(this.querySelectorAll('[data-countdown]'));
        this.mobileMedia = window.matchMedia('(max-width: 989px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
        this.rotationTimer = null;
        this.countdownTimer = null;
        this.isInViewport = true;
  
        this.countdowns.forEach((countdown) => {
          countdown.endTime = this.parseDate(countdown.dataset.countdownEnd)?.getTime() || 0;
        });
  
        this.onMediaChange = this.updateDisplay.bind(this);
        this.onVisibilityChange = this.handleVisibility.bind(this);
        this.onClick = this.handleClick.bind(this);
        this.onPointerEnter = this.stopRotation.bind(this);
        this.onPointerLeave = this.startRotation.bind(this);
        this.onFocusIn = this.stopRotation.bind(this);
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.startRotation();
        };
        this.onIntersection = ([entry]) => {
          this.isInViewport = entry?.isIntersecting ?? true;
          this.refreshActivity();
        };
  
        this.addEventListener('click', this.onClick, true);
        this.addEventListener('pointerenter', this.onPointerEnter);
        this.addEventListener('pointerleave', this.onPointerLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileMedia.addEventListener('change', this.onMediaChange);
        this.reducedMotion.addEventListener('change', this.onMediaChange);
  
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(this.onIntersection, { rootMargin: '80px 0px' });
          this.intersectionObserver.observe(this);
        }
  
        this.updateDisplay();
        this.startCountdowns();
      }
  
      disconnectedCallback() {
        this.stopRotation();
        this.stopCountdowns();
        this.intersectionObserver?.disconnect();
        this.removeEventListener('click', this.onClick, true);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileMedia?.removeEventListener('change', this.onMediaChange);
        this.reducedMotion?.removeEventListener('change', this.onMediaChange);
        this.initialized = false;
      }
  
      updateDisplay() {
        this.stopRotation();
  
        if (this.mobileMedia.matches) {
          this.showMessage(this.activeIndex);
          this.startRotation();
          return;
        }
  
        this.messages.forEach((message) => {
          message.classList.add('is-active');
          message.removeAttribute('aria-hidden');
          message.querySelectorAll('button, [href]').forEach((control) => {
            control.removeAttribute('tabindex');
          });
        });
      }
  
      showMessage(index) {
        if (!this.messages.length) return;
        this.activeIndex = (index + this.messages.length) % this.messages.length;
  
        this.messages.forEach((message, messageIndex) => {
          const active = messageIndex === this.activeIndex;
          message.classList.toggle('is-active', active);
          message.setAttribute('aria-hidden', active ? 'false' : 'true');
          message.querySelectorAll('button, [href]').forEach((control) => {
            control.tabIndex = active ? 0 : -1;
          });
        });
      }
  
      startRotation() {
        this.stopRotation();
        if (!this.mobileMedia.matches || this.reducedMotion.matches || document.hidden || !this.isInViewport || this.messages.length < 2) return;
  
        const interval = Math.max(Number(this.dataset.rotationInterval) || 4000, 2000);
        this.rotationTimer = window.setInterval(() => this.showMessage(this.activeIndex + 1), interval);
      }
  
      stopRotation() {
        window.clearInterval(this.rotationTimer);
        this.rotationTimer = null;
      }
  
      handleVisibility() {
        this.refreshActivity();
      }
  
      refreshActivity() {
        if (document.hidden || !this.isInViewport) {
          this.stopRotation();
          this.stopCountdowns();
          return;
        }
  
        this.startRotation();
        this.startCountdowns();
      }
  
      async handleClick(event) {
        if (event.target.matches?.('[data-contact-dialog]')) {
          event.target.close();
          return;
        }
  
        const copyButton = event.target.closest('[data-copy-code]');
        if (copyButton) {
          event.preventDefault();
          event.stopPropagation();
          const code = copyButton.dataset.copyCode;
          if (!code) return;
  
          const originalText = copyButton.textContent.trim();
          try {
            await navigator.clipboard.writeText(code);
            copyButton.textContent = this.dataset.copiedText || 'Copied';
            window.setTimeout(() => { copyButton.textContent = originalText; }, 1800);
          } catch (error) {
            copyButton.textContent = code;
          }
          return;
        }
  
        const trigger = event.target.closest('[data-contact-trigger]');
        if (trigger) {
          event.preventDefault();
          const dialog = document.getElementById(trigger.dataset.contactTrigger);
          if (dialog?.showModal) dialog.showModal();
          return;
        }
  
        const closeButton = event.target.closest('[data-dialog-close]');
        if (closeButton) {
          event.preventDefault();
          closeButton.closest('dialog')?.close();
        }
      }
  
      parseDate(value) {
        if (!value) return null;
        const date = new Date(value.trim().replace(' ', 'T'));
        return Number.isNaN(date.getTime()) ? null : date;
      }
  
      startCountdowns() {
        this.stopCountdowns();
        if (!this.countdowns.length || document.hidden || !this.isInViewport) return;
  
        const nextUpdate = this.updateCountdowns();
        if (nextUpdate !== null) {
          this.countdownTimer = window.setTimeout(() => this.startCountdowns(), nextUpdate);
        }
      }
  
      stopCountdowns() {
        window.clearTimeout(this.countdownTimer);
        this.countdownTimer = null;
      }
  
      updateCountdowns() {
        const now = Date.now();
        let nextUpdate = null;
  
        this.countdowns.forEach((countdown) => {
          const output = countdown.querySelector('[data-countdown-output]');
          if (!output || !countdown.endTime) return;
  
          const difference = countdown.endTime - now;
          if (difference <= 0) {
            output.textContent = countdown.dataset.expiredText || 'Expired';
            return;
          }
  
          const totalSeconds = Math.floor(difference / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          const pad = (number) => String(number).padStart(2, '0');
  
          output.textContent = days > 0
            ? `${days}${this.dataset.daysLabel} ${pad(hours)}${this.dataset.hoursLabel} ${pad(minutes)}${this.dataset.minutesLabel}`
            : `${pad(hours)}${this.dataset.hoursLabel} ${pad(minutes)}${this.dataset.minutesLabel} ${pad(seconds)}${this.dataset.secondsLabel}`;
  
          const precision = days > 0 ? 60000 : 1000;
          const delay = Math.max((difference % precision) + 25, 250);
          nextUpdate = nextUpdate === null ? delay : Math.min(nextUpdate, delay);
        });
  
        return nextUpdate;
      }
    }
  
    customElements.define('fast-contact-usp-bar', FastContactUspBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-kampagne-top-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('campaign-top-bar')) {
    customElements.define('campaign-top-bar', class CampaignTopBar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        window.clearTimeout(this.resetTimer);
        this.initialized = false;
      }

      handleClick = async (event) => {
        const button = event.target.closest('[data-copy-code]');
        if (!button || !this.contains(button)) return;

        const code = button.dataset.copyCode;
        const codeText = button.querySelector('[data-code-text]');
        const status = this.querySelector('[data-copy-status]');
        if (!code || !codeText) return;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
          } else {
            const textArea = document.createElement('textarea');
            textArea.value = code;
            textArea.setAttribute('readonly', '');
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          const copiedText = this.dataset.copiedText || 'Kopieret';
          window.clearTimeout(this.resetTimer);
          codeText.textContent = copiedText;
          button.classList.add('is-copied');
          if (status) status.textContent = `${copiedText}: ${code}`;

          this.resetTimer = window.setTimeout(() => {
            codeText.textContent = code;
            button.classList.remove('is-copied');
            if (status) status.textContent = '';
          }, 1800);
        } catch (error) {
          if (status) status.textContent = `Kunne ikke kopiere. Koden er ${code}`;
        }
      };
    });
  }

  } catch(e) { console.error(e); }
})();
})();
